import '~/src/prismjs';

import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import BackupIcon from '@material-ui/icons/Backup';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import { Autocomplete } from '@material-ui/lab';
import { cloneDeep } from 'lodash';
import { MTableToolbar } from 'material-table';
import React, { ChangeEvent, ReactElement } from 'react';
import update from 'react-addons-update';

import { getBidderGroups, IBidderGroup } from '~/src/dash/api/bidder-group';
import {
  BRAND_SAFETY_TARGETING_PILLS,
  BrandSafetyRuleActiveActive,
  BrandSafetyRuleActiveInactive,
  BrandSafetyRuleTargetingAdomainExceptionStateAllowAll,
  BrandSafetyRuleTargetingAdomainExceptionStateContains,
  BrandSafetyRuleTargetingAdomainExceptionStateExactMatch,
  BrandSafetyRuleTargetingTypeBidder,
  BrandSafetyRuleTargetingTypeBidderGroup,
  BrandSafetyRuleTargetingTypeChannel,
  BrandSafetyRuleTargetingTypeChannelGroup,
  BrandSafetyRuleTargetingTypeGlobal,
  brandSafetyRuleTypeToNumber,
  brandSafetyRuleTypeToString,
  brandSafetyTargetingTypeToNumber,
  brandSafetyTargetingTypeToString,
  getBrandSafetyTypePills,
  IBrandSafetyRule,
  IBrandSafetyRuleAssociationTable,
  IBrandSafetyRuleException,
  RuleTypeAdomain,
  RuleTypeCreativeID,
  RuleTypeEventTracker,
  RuleTypeIAB,
  RuleTypeLanguage,
  RuleTypeMediafile,
  targetingTypeToString,
} from '~/src/dash/api/brand-safety-rules';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import {
  EAllowStatus,
  HeaderBidderActiveActive,
  IChannelGroup,
  ICountryGroup,
  IHeaderBidder,
  ISite,
  queryHeaderBidders,
  TargetingCCPAAll,
  TargetingCoppa0,
  TargetingCoppaAll,
} from '~/src/dash/api/console-api';
import {
  commonRegionGroupsIDs,
  createCountryGroup,
  deleteCountryGroup,
  getCountryGroupsByIDs,
  getCountryGroupsByPublisherID,
  updateCountryGroup,
} from '~/src/dash/api/country-group';
import {
  getCreativeValidationsV2,
  ICreativeValidation,
  REVIEW_STATUS_ALLOWED,
} from '~/src/dash/api/creative-validation';
import { getLanguagesAsIMenuList } from '~/src/dash/api/languages';
import { createUrl, IHttpResponse, restDelete, restPatch, restPost } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import {
  IIncludeExcludeTableElement,
  IncludeExcludeTable,
  SourceBrandSafetyRuleEdit,
} from '~/src/dash/components/include-exclude-table';
import InputGridRow from '~/src/dash/components/input-grid-row';
import { IInputRow, InputRow } from '~/src/dash/components/input-row';
import { spacing } from '~/src/dash/components/layout/common';
import {
  IBrandSafetyRuleAdomainExceptionRowData,
  IBrandSafetyRuleExceptionRowData,
  ICountryGroupRowData,
  IListTableColumn,
  ListTable,
} from '~/src/dash/components/list-table';
import {
  excludedTitleOverride,
  ILocalTargetingParameter,
  includedTitleOverride,
  LocalTargeting,
  validateLocalTargetingRule,
} from '~/src/dash/components/local-targeting/local-targeting';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModalSelectTable } from '~/src/dash/components/modal-select-table';
import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';
import { ModelDialogDeleteView } from '~/src/dash/components/model-dialog-delete-view';
import ElevationScroll from '~/src/dash/components/model-elevation-scroll';
import { ModelMediumButton } from '~/src/dash/components/model-medium-button';
import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import PillSwitcher from '~/src/dash/components/pill-switcher';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import { Text } from '~/src/dash/components/text';
import { Col, Cols, Panel, Panels, Row, Rows } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { getColorTheme, getResellerTitle } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  extractRouteParams,
  navigate,
  RouteBidderSettingsExisting,
  RouteBrandSafetyEdit,
  RouteBrandSafetyList,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { getDomain } from '~/src/dash/utils/brand-safety-rules';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  generateCountriesMenuList,
  generateCountryMenuListFromIsos,
  generateNewTargetingCountryGroupList,
  getAllCountries,
} from '~/src/dash/utils/countries';
import { decorate } from '~/src/dash/utils/decorator';
import { IEndpointBuilderChip } from '~/src/dash/utils/endpointBuilderService';
import {
  getAllIABCategories,
  IAB_CATEGORIES,
  IABCategoryCodeToName,
} from '~/src/dash/utils/iab-category';
import {
  bigRadius,
  deleteColor,
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import { noopVoid } from '~/src/dash/utils/noop';
import { exportLocalTargetingToJSON } from '~/src/dash/utils/params';
import {
  allowedEmptyIPermissionCheck,
  IPermissionCheck,
  IS_AUTHORIZED,
  notAllowedEmptyIPermissionCheck,
} from '~/src/dash/utils/permission_service';
import { checkUserInfoMasked, hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { allSupportedStates, ICountryState, stateNamesToStateList } from '~/src/dash/utils/states';
import { toTitleCase } from '~/src/dash/utils/text-tools';
import { USCities } from '~/src/dash/utils/us-cities';
import {
  hasErrors,
  IErrors,
  regionValidationSetting,
  validatorFactory,
} from '~/src/dash/utils/validator';
import { ccpaOptions, coppaOptions } from '~/src/dash/views/bidder-settings-form-view';
import { ButtonView } from '~/src/dash/views/button-view';
import { SelectMode } from '~/src/dash/views/campaign/campaign-form-view';
import { RowButton } from '~/src/dash/views/component-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  rule: IBrandSafetyRule;
  error: string;
}

interface IState extends IBaseState, IBrandSafetyRule {
  // snackbar ??
  loading: boolean;
  updating: boolean;
  snackbarMessage: string;
  snackbarError: boolean;
  // delete confirmation popup
  deletePopupActive: boolean;
  // rule type - see BrandSafetyRuleType enum form brand-safety-rules.ts
  ruleType: number;
  // menu list for the rule targeting selection dropdowns
  channelList: IMenuList; // channel
  channelGroupList: IMenuList; // channel group
  bidderList: IMenuList; // bidder
  bidderGroupList: IMenuList; // bidder list
  // IAB
  iabList: IIncludeExcludeTableElement[]; // list of IAB displayed in the table
  userEntryIABPrefix: string; // IAB prefix of user's current entry
  userEntryIABSuffix: string; // IAB suffix of user's current entry
  userEntryIABList: string; // user's entry of comma separated IAB codes
  // Adomain
  adomain: string[]; // adomain list - displayed in the table
  adomainUserEntry: string; // adomain single user entry
  // Mediafile
  mediafiles: string[];
  mediafileUserEntry: string; // mediafile single user entry
  // Creative ID
  creativeIDs: string[]; // creative ID list - displayed in the table
  creativeIDUserEntry: string; // creative ID single user entry
  // Languages
  languages: string[];
  languageList: IMenuList; // language multi-select-dropdown
  // Event Trackers
  eventTrackers: string[];
  eventTrackerUserEntry: string;
  TargetedEventTracker: string;
  // permissions
  hasPublisherWriteRight: IPermissionCheck;
  hasChannelWriteRight: IPermissionCheck;
  hasBidderWriteRight: IPermissionCheck;
  hasWriteCurrentRuleRight: IPermissionCheck;

  writeAuthorization: IPermissionCheck;

  targetingCountriesList: IMenuList;
  targetingCountryGroupList: IMenuList;
  localTargetingAllowedParameters: ILocalTargetingParameter[];
  localTargetingDisallowedParameters: ILocalTargetingParameter[];
  publisherCountryGroups: ICountryGroup[];
  createEditRegionName: string;
  createEditRegionList: IMenuList;
  createEditRegionID: string;
  updatingCountryGroup: boolean;
  openRegionCreateEditDialog: boolean;
  openRegionSelectDialog: boolean;
  openRegionSelectTable: boolean;
  deviceTargetingCountrySelectMode: SelectMode;
  errors: IErrors;
  commonRegionGroups: ICountryGroup[] | undefined;
  // creative validations
  allowedCreativeValidations: ICreativeValidation[];
  loadingCreativeValidations: boolean;
  openRuleTargetedExceptionDialog: boolean;
  openRuleTargetedExceptionDialogIABCode: string;
  selectedRowIdx: number | undefined;
}

// chips for targeting type selection
const ChipTargetingTypeUnselected = createChipWihFadingBackgroundVariations(
  '#707070',
  'rgba(131,131,131,0.1)',
  'rgb(131,131,131,0.05)',
  'rgb(131,131,131,0.15)',
);
const ChipTargetingTypeSelected = createChipWihFadingBackgroundVariations(
  '#6761FC',
  'rgba(0,10,255,0.1)',
  'rgba(0,10,255,0.05)',
  'rgba(0,10,255,0.15)',
);

const ChipTypeSelected = createChipWihFadingBackgroundVariations(
  '#FF5050',
  'rgb(255,0,0,0.1)',
  'rgb(255,0,0,0.05)',
  'rgb(255,0,0,0.15)',
);

// enum for tab ()
const RuleTargetingTab = 1;
const RuleExceptionTab = 2;
const isRuleTargetingTab = (tab: number): boolean => {
  return tab === RuleTargetingTab;
};

// regex that tests if an IAB string is correct or not
// see https://regex101.com/r/Hivbch/1
const iabRegexp = /^IAB\d+(-\d+)?$/;

// regex that checks if a string is an adomain
// see https://regex101.com/r/CIGTP2/1
const adomainRegexp = /^([a-z0-9][a-z0-9-]{1,61}[a-z0-9]\.)+[a-z]{2,4}(\.[a-z]{2,4})?$/;

// regex that check if a string is a mediafile domain
// see https://regex101.com/r/kJbHWZ/1
const mediafileDomainRegexp =
  /^(https?:\/\/)?([a-z0-9]{0}[a-z0-9-]{0,61}[a-z0-9]{1}\.)+[a-z]{2,4}(\.[a-z]{2,4}){0,1}(\/.*){0,9}$/;

// define the brand safety rule exception table columns
const listTableColumns: IListTableColumn[] = [
  { field: 'Name', title: 'Name', renderType: 'modal', searchable: true, maxWidth: '200px' },
  {
    field: 'BidderIDs',
    title: 'Bidder IDs',
    renderType: 'modal2',
    searchable: false,
    maxWidth: '200px',
  },
  {
    field: 'AllowedAdomains',
    title: 'Allowed Adomains',
    renderType: 'normal',
    searchable: false,
    maxWidth: '200px',
  },
  {
    field: 'AllowedIABCategories',
    title: 'Allowed IAB Categories',
    renderType: 'normal',
    searchable: false,
    maxWidth: '200px',
  },
  { field: 'Actions', title: 'Actions', renderType: 'delete', searchable: false },
];

const getHelperText = (exactMatch: boolean): string => {
  if (exactMatch) {
    switch (getResellerTitle()) {
      case 'OTTera':
        return 'ads.ottera.tv matches with https://ottera.tv, www.ottera.tv/';
      case 'Evrideo':
        return 'evrideo-ads.tv matches with https://evrideo-ads.tv, www.evrideo-ads.tv/';
      case 'Orka':
        return 'pacific.orka.biz matches with https://orka.biz, www.orka.biz/';
      case 'Philo':
        return 'ads.philo.com matches with https://philo.com, www.philo.com/';
      default:
        return 'getpublica.com matches with https://getpublica.com, www.getpublica.com/';
    }
  } else {
    switch (getResellerTitle()) {
      case 'OTTera':
        return 'ottera matches with https://ottera.tv, www.ottera.tv/';
      case 'Evrideo':
        return 'evrideo matches with https://evrideo-ads.tv, www.evrideo-ads.tv/';
      case 'Orka':
        return 'orka matches with https://orka.biz, www.orka.biz/';
      case 'Philo':
        return 'philo matches with https://philo.com, www.philo.com/';
      default:
        return 'publica matches with https://getpublica.com, ttps://getpublica.fr, www.getpublica.com/';
    }
  }
};

export const BrandSafetyRuleEdit = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 6,
        paddingLeft: theme.spacing.unit * 6 + 'px !important',
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      campaignNameContainer: {
        display: 'inline-block',
        marginLeft: '10px',
        width: 'calc(50% - 2em)',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 3,
      },
      button: {
        margin: theme.spacing.unit,
      },
      button2: {
        marginLeft: theme.spacing.unit * 6,
        border: 'none',
      },
      button3: {
        marginLeft: theme.spacing.unit * 4,
        border: 'none',
      },
      centeredSwitch: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '60px',
      },
      textCenteredSpan: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      spanDescription: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      spanActive: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '55px',
        fontWeight: 'bold',
      },
      uploadButton: {
        display: 'flex',
        'text-align': 'center',
      },
      datePickerSection: {
        display: 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      table: {
        display: 'inline-block',
        marginTop: '10px',
        marginBottom: '10px',
      },
      danger: {
        color: 'red',
      },
      success: {
        color: 'green',
      },
      chip: {
        '&.MuiChip-colorPrimary': {
          backgroundColor: getColorTheme('chipSelectActiveBackground') + ' !important',
        },
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = this.assignBrandSafetyRuleToState();
    }

    assignBrandSafetyRuleToState = (): IState => {
      return {
        // insert rule in state
        ...this.props.rule,
        loading: false,
        updating: false,
        snackbarMessage: '',
        snackbarError: false,
        // delete confirmation popup
        deletePopupActive: false,
        // rule type - see BrandSafetyRuleType enum form brand-safety-rules.ts
        ruleType: RuleTypeIAB,
        // menu list for the selection dropdowns
        channelList: {} as IMenuList, // channel
        channelGroupList: {} as IMenuList, // channel group
        bidderList: {} as IMenuList, // bidder
        bidderGroupList: {} as IMenuList, // bidder list
        // IAB
        iabList: [] as IIncludeExcludeTableElement[], // list of IAB displayed in the table
        userEntryIABPrefix: '', // IAB prefix of user's current entry
        userEntryIABSuffix: '', // IAB suffix of user's current entry
        userEntryIABList: '', // user's entry of comma separated IAB codes
        // Adomain
        adomain: [] as string[], // adomain list - displayed in the table
        adomainUserEntry: '', // adomain single user entry
        subtitle: [] as IEndpointBuilderChip[],
        // Mediafile
        mediafiles: [] as string[],
        mediafileUserEntry: '',
        // CreativeIDs
        creativeIDs: [] as string[],
        creativeIDUserEntry: '',
        // Languages
        languages: [] as string[],
        languageList: {} as IMenuList,
        // EventTrackers
        eventTrackers: [] as string[],
        eventTrackerUserEntry: '',
        TargetedEventTracker: '',
        // Arrays to store info for allowed IAB and Adomains in each exceptions
        channels: [] as ISite[],
        channelGroups: [] as IChannelGroup[],
        headerBidders: [] as IHeaderBidder[],
        bidderListAllowed: {} as IMenuList,
        iabListAllowed: [] as IIncludeExcludeTableElement[], // list of IAB displayed in the table - in exception panel
        userEntryIABPrefixAllowed: '', // IAB prefix of user's current entry - in exception panel
        userEntryIABSuffixAllowed: '', // IAB suffix of user's current entry - in exception panel
        userEntryIABListAllowed: '', // user's entry of comma separated IAB codes - in exception panel
        adomainAllowed: [] as string[], // adomain list - displayed in the table - in exception panel
        adomainUserEntryAllowed: '', // adomain single user entry - in exception panel
        // permissions
        hasPublisherWriteRight:
          notAllowedEmptyIPermissionCheck /* TODO uncomment to release global targeting - IS_AUTHORIZED(['write_publisher_brandsafety_rule'], this.props.user.user) */,
        hasChannelWriteRight: IS_AUTHORIZED(
          ['write_channel_brandsafety_rule'],
          this.props.user.user,
        ),
        hasBidderWriteRight: IS_AUTHORIZED(
          ['write_channel_brandsafety_rule'],
          this.props.user.user,
        ),
        hasWriteCurrentRuleRight: allowedEmptyIPermissionCheck,
        openEditRuleException: false,
        openBidderSelectTable: false,
        selectedRowIdx: undefined,
        writeAuthorization: IS_AUTHORIZED(['write_channel_brandsafety_rule'], this.props.user.user),
        localTargetingAllowedParameters: [] as ILocalTargetingParameter[],
        localTargetingDisallowedParameters: [] as ILocalTargetingParameter[],
        // createEditRegionList: {} as IMenuList,
        publisherCountryGroups: [] as ICountryGroup[],
        createEditRegionID: '',
        createEditRegionName: '',
        createEditRegionList: generateCountriesMenuList(),
        targetingCountryGroupList: {} as IMenuList,
        targetingCountriesList: generateCountriesMenuList(),
        updatingCountryGroup: false,
        openRegionCreateEditDialog: false,
        openRegionSelectDialog: false,
        openRegionSelectTable: false,
        deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        errors: {} as IErrors,
        commonRegionGroups: [] as ICountryGroup[],
        // creative validations
        allowedCreativeValidations: [] as ICreativeValidation[],
        loadingCreativeValidations: false,
        openRuleTargetedExceptionDialog: false,
        openRuleTargetedExceptionDialogIABCode: '',
      };
    };

    // initialization function
    componentDidMount() {
      // handle loading error
      if (this.props.error !== '') {
        // display error message to user
        this.setState({
          snackbarError: true,
          snackbarMessage: this.props.error,
        });
        // return to main page after 3 secs
        setTimeout(this.navigateToRuleListView, 3000);
        // stop initialization here
        return;
      }
      // specific for existing rules
      if (this.state.ID !== 0) {
        // for existing rules → checks if the user has the write rights
        this.checkIfUserHasWriteRight();
        // for existing rules → rule type initialization
        this.initializeIABList();
        this.initializeAdomainList();
        this.initializeMediafileList();
        this.initializeCreativeIDList();
        this.initializeEventTrackerList();
      }
      this.initializeLanguageList();
      // channel, bidder ... dropdown initialization
      this.initializeChannelList();
      this.initializeChannelGroupList();
      this.initializeBidderList();
      this.initializeBidderGroupList();
      // Geo
      this.getCountryGroupsByPublisherID();
      this.populateTargetingCountriesList();
      this.importLocalTargetingParamFromJSON(true, this.state.LocalTargetingAllowed);
      this.importLocalTargetingParamFromJSON(false, this.state.LocalTargetingDisallowed);
      this.getCommonRegionGroupsByIDs();

      this.getCreativeValidationsAllowed();
      this.setChipDefault();
      this.initializeMenuListFromTargetedIABs();
    }

    // gets if the current user had the write right on the current rule and save it in the state
    checkIfUserHasWriteRight(): void {
      let rights = allowedEmptyIPermissionCheck;
      switch (this.state.RuleTargetingType) {
        case BrandSafetyRuleTargetingTypeGlobal:
          rights = this.state.hasPublisherWriteRight;
          break;
        case BrandSafetyRuleTargetingTypeChannel:
        case BrandSafetyRuleTargetingTypeChannelGroup:
          rights = this.state.hasChannelWriteRight;
          break;
        case BrandSafetyRuleTargetingTypeBidder:
        case BrandSafetyRuleTargetingTypeBidderGroup:
          rights = this.state.hasBidderWriteRight;
          break;
      }
      this.setState({
        hasWriteCurrentRuleRight: rights,
      });
    }

    // initialize the list of Adomain when loading an existing rule
    initializeAdomainList(): void {
      // checks if rule is Adomain type
      if (this.state.TargetedAdomains === '') {
        return; // rule is not an IAB rule
      }
      // rule in an Adomain rule
      // need to userEntryIABPrefixAllowed, userEntryIABSuffixAllowed, userEntryIABListAllowed, adomain
      this.setState({
        ruleType: RuleTypeAdomain,
        adomain: this.state.TargetedAdomains.split(','),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedIABCategories.split(',').map(
            (iabCode: string) =>
              ({
                ID: iabCode.replace('!', ''),
                title: iabCode.replace('!', ''),
                included: true,
              }) as IIncludeExcludeTableElement,
          ),
        ),
      });
    }

    // initializes the list of IAB when loading an existing rule
    initializeIABList(): void {
      // checks if rule is IAB type
      if (this.state.TargetedIABs === '') {
        return; // rule is not an IAB rule
      }
      // rule is an IAB rule
      this.setState({
        ruleType: RuleTypeIAB,
        iabList: this.state.TargetedIABs.split(',').map(
          (iabCode: string) =>
            ({
              ID: iabCode.replace('!', ''),
              title: iabCode.replace('!', ''),
              name: IABCategoryCodeToName(iabCode),
              included: !iabCode.startsWith('!'),
            }) as IIncludeExcludeTableElement,
        ),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    initializeLanguageList(): void {
      // if an existing rule that is a Language rule, set languageList to rule's selected languages
      if (this.state.ID !== 0 && this.state.TargetedLanguages !== '') {
        const languageList = this.state.TargetedLanguages.split(',');
        this.setState({
          ruleType: RuleTypeLanguage,
          languages: languageList,
          languageList: getLanguagesAsIMenuList(languageList),
        });
      } else {
        // if its a new rule or not a language rule
        this.setState({
          languageList: getLanguagesAsIMenuList(),
        });
      }
    }

    initializeMediafileList(): void {
      // checks if rule is Mediafile type
      if (this.state.TargetedMediafiles === '') {
        return; // rule is not a Mediafile rule
      }
      // rule in a Mediafile rule
      this.setState({
        ruleType: RuleTypeMediafile,
        mediafiles: this.state.TargetedMediafiles.split('\t'),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedIABCategories.split(',').map(
            (iabCode: string) =>
              ({
                ID: iabCode.replace('!', ''),
                title: iabCode.replace('!', ''),
                included: true,
              }) as IIncludeExcludeTableElement,
          ),
        ),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    initializeCreativeIDList(): void {
      // checks if rule is creativeID type
      if (this.state.TargetedCreativeIDs === '') {
        return; // rule is not a creativeID rule
      }
      // rule in a creativeID rule
      this.setState({
        ruleType: RuleTypeCreativeID,
        creativeIDs: this.state.TargetedCreativeIDs.split(','),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedIABCategories.split(',').map(
            (iabCode: string) =>
              ({
                ID: iabCode.replace('!', ''),
                title: iabCode.replace('!', ''),
                included: true,
              }) as IIncludeExcludeTableElement,
          ),
        ),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    initializeEventTrackerList(): void {
      // checks if rule is event tracker type
      if (this.state.TargetedEventTrackers === '') {
        return;
      }
      // rule is an event tracker rule
      this.setState({
        ruleType: RuleTypeEventTracker,
        eventTrackers: this.state.TargetedEventTrackers.split('\t'),
      });
    }

    initializeBidderGroupList() {
      // get bidder group list from API
      getBidderGroups({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then(({ bidderGroups }: { bidderGroups: IBidderGroup[] }) => {
        // transform the bidder group list to a menu list
        const menuBidderGroupList = {} as IMenuList;
        bidderGroups.forEach((bidderGroup: IBidderGroup) => {
          const bidderGroupName = checkUserInfoMasked(this.props.user.user)
            ? 'BidderGroup_' + bidderGroup.ID // masked info
            : `${bidderGroup.Name}: (${bidderGroup.BidderIDs.split(',').length} Bidders)`; // real name
          menuBidderGroupList[bidderGroup.ID] = {
            title: bidderGroupName,
            selected:
              this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeBidderGroup &&
              this.state.TargetedObjects.filter((t) => t.TargetID === Number(bidderGroup.ID))
                .length > 0,
            ID: bidderGroup.ID,
          };
        });
        // assign the menu list to the state
        this.setState({
          bidderGroupList: menuBidderGroupList,
        });
      });
    }

    initializeBidderList() {
      // get bidder list from API
      queryHeaderBidders({
        query: {
          publisher_id: this.props.session.publisher.ID,
          site_ids: '',
          include_deleted: false,
        },
      }).then((headerBidders: IHeaderBidder[]) => {
        // filter bidder to keep only active
        headerBidders = headerBidders.filter(
          (hb: IHeaderBidder) => hb.Active === HeaderBidderActiveActive,
        );
        // transform the bidder list into a menu list
        const menuBidderList = {} as IMenuList;
        headerBidders.forEach((hb: IHeaderBidder) => {
          const bidderName = checkUserInfoMasked(this.props.user.user)
            ? 'Bidder_' + hb.ID
            : hb.Name;
          menuBidderList[hb.ID] = {
            title: bidderName,
            selected:
              this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeBidder &&
              this.state.TargetedObjects.filter((t) => t.TargetID === Number(hb.ID)).length > 0,
            ID: hb.ID,
          };
        });
        // set state
        this.setState({
          headerBidders: this.enrichBidders(headerBidders),
          bidderList: menuBidderList,
        });
      });
    }

    enrichBidders = (bidderList: IHeaderBidder[]): IHeaderBidder[] => {
      // For all bidder in list
      for (let i = 0; i < bidderList.length; i++) {
        // Enrich the bidder channel list /w all the channel included in the channel-group targeting
        // For all bidder channel-group targeting
        for (const channelGroup of bidderList[i].ChannelGroups) {
          // For all channel in channel-group
          for (const channelIDStr of channelGroup.ChannelIDs.split(',')) {
            // If this channel-group's channel is valid, then insert it in bidder's channel targeting
            const channelIdNbr = Number(channelIDStr);
            if (!isNaN(channelIdNbr) && channelIdNbr !== 0) {
              bidderList[i].SiteIDS.push(channelIdNbr);
            }
          }
        }

        // Dedup the bidder channel list and remove the channel that can't be found in state.activeSites
        const dedupMap = new Map();
        const newChannelList: number[] = [];
        for (const siteID of bidderList[i].SiteIDS) {
          // Check duplication
          if (!dedupMap.has(siteID)) {
            // Duplication ok, check if channel exists in state.activeSites
            dedupMap.set(siteID, true);
            newChannelList.push(siteID);
          }
        }
        bidderList[i].SiteIDS = newChannelList;
      }

      return bidderList;
    };

    // initialize state.channelGroupList for channel group selector
    initializeChannelGroupList() {
      // get channel groups from API
      getChannelGroupsPromise({
        publisherID: this.props.session.publisher.ID,
      }).then(({ channelGroups }: { channelGroups: IChannelGroup[] }) => {
        // transform the channel group list to a menu list
        const menuChannelGroupList = {} as IMenuList;

        channelGroups.forEach((channelGroup: IChannelGroup) => {
          const channelGroupName = checkUserInfoMasked(this.props.user.user)
            ? 'ChannelGroup_' + channelGroup.ID // masked info
            : `${channelGroup.Name}: (${channelGroup.SitesInfo.length} Sites)`; // real name

          const isSelectedChannelGroup =
            this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup &&
            this.state.TargetedObjects.filter((t) => t.TargetID === Number(channelGroup.ID))
              .length > 0;

          menuChannelGroupList[channelGroup.ID] = {
            title: channelGroupName,
            selected: isSelectedChannelGroup,
            ID: channelGroup.ID.toString(),
          };
        });
        // assign the menu list to the state
        this.setState({
          channelGroups,
          channelGroupList: menuChannelGroupList,
        });
      });
    }

    // initialize state.channelList for channel selector
    async initializeChannelList() {
      // get active channels from session
      const [small_sites, err] = await getSmallSites(this.props.session.publisher.ID);
      if (err) {
        console.error(err);
        return;
      }

      const activeChannels = filterSitesByActive(small_sites || []);
      // transform the channels list to a menu list
      const menuChannelList = {} as IMenuList;

      activeChannels.forEach((site: ISmallSite) => {
        const channelName = checkUserInfoMasked(this.props.user.user)
          ? 'Channel_' + site.ID
          : site.Name;
        const isSelectedChannel =
          this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannel &&
          this.state.TargetedObjects.filter((t) => t.TargetID === Number(site.ID)).length > 0;

        menuChannelList[site.ID] = {
          title: channelName,
          selected: isSelectedChannel,
          ID: site.ID.toString(),
        };
      });
      // assign the menu list to the state
      this.setState({
        channels: activeChannels,
        channelList: menuChannelList,
      });
    }

    // [LocalTargeting] importLocalTargetingParamFromJSON imports JSON to local targeting params
    importLocalTargetingParamFromJSON = (allowed: boolean, inputJSON: string): void => {
      if (inputJSON === undefined || inputJSON.length === 0) {
        return;
      }
      let localParams: ILocalTargetingParameter[] = [];
      try {
        localParams = (JSON.parse(inputJSON) as object[]).map((o: ILocalTargetingParameter) => ({
          ...o,
          currentValue: '',
          isInputInCommaSeparatedMode: false,
        }));
      } catch (e) {
        // Ignore JSON parse errors
      }
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: localParams,
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: localParams,
        });
      }
    };

    saveRule() {
      // transform state into IBrandSafetyRule object
      const selectedCountryGroupItems = Object.values(this.state.targetingCountryGroupList).filter(
        (item: IListItem) => item.selected,
      );
      const selectedCountries = Object.values(this.state.targetingCountriesList).filter(
        (item: IListItem) => item.selected,
      );
      const rule = {
        ID: this.state.ID,
        PublisherID: this.state.PublisherID,
        Name: this.state.Name,
        Active: this.state.Active,
        RuleTargetingType: this.state.RuleTargetingType,
        NbrResponseBlocked: this.state.NbrResponseBlocked,
        IsTargetingExcluded:
          this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeGlobal
            ? false
            : this.state.IsTargetingExcluded,
        IsTypeTargetingExcluded: this.state.IsTypeTargetingExcluded,
        BrandSafetyRuleExceptions: this.state.BrandSafetyRuleExceptions.filter(
          (exception: IBrandSafetyRuleException) => {
            if (
              this.state.TargetingAdomainExceptionState ===
              BrandSafetyRuleTargetingAdomainExceptionStateAllowAll
            ) {
              return true;
            }
            // remove exception from list if both AllowedAdomains and AllowedIABCategories are empty
            return !(exception.AllowedAdomains === '' && exception.AllowedIABCategories === '');
          },
        ),
        TargetedObjects: this.CreateTargetedObjectsTable(),
        EnableSaveCreativeValidations: this.state.EnableSaveCreativeValidations,
        EnableBlockBidsWithEmptyIABCatAdomain: this.state.EnableBlockBidsWithEmptyIABCatAdomain,
        // Targeted Content
        TargetedContentCategory: this.state.TargetedContentCategory,
        TargetedContentCategoryIsAllowed: this.state.TargetedContentCategoryIsAllowed,
        TargetedContentChannel: this.state.TargetedContentChannel,
        TargetedContentChannelIsAllowed: this.state.TargetedContentChannelIsAllowed,
        TargetedContentDistributor: this.state.TargetedContentDistributor,
        TargetedContentDistributorIsAllowed: this.state.TargetedContentDistributorIsAllowed,
        TargetedContentGenre: this.state.TargetedContentGenre,
        TargetedContentGenreIsAllowed: this.state.TargetedContentGenreIsAllowed,
        TargetedContentID: this.state.TargetedContentID,
        TargetedContentIDIsAllowed: this.state.TargetedContentIDIsAllowed,
        TargetedContentNetwork: this.state.TargetedContentNetwork,
        TargetedContentNetworkIsAllowed: this.state.TargetedContentNetworkIsAllowed,
        TargetedContentProducer: this.state.TargetedContentProducer,
        TargetedContentProducerIsAllowed: this.state.TargetedContentProducerIsAllowed,
        TargetedContentRating: this.state.TargetedContentRating,
        TargetedContentRatingIsAllowed: this.state.TargetedContentRatingIsAllowed,
        TargetedContentSeries: this.state.TargetedContentSeries,
        TargetedContentSeriesIsAllowed: this.state.TargetedContentSeriesIsAllowed,
        TargetedContentTitle: this.state.TargetedContentTitle,
        TargetedContentTitleIsAllowed: this.state.TargetedContentTitleIsAllowed,

        // targeting app/site
        TargetedAppBundleID: this.state.TargetedAppBundleID,
        TargetedAppBundleIDIsAllowed: this.state.TargetedAppBundleIDIsAllowed,
        TargetedSitePages: this.state.TargetedSitePages,
        TargetedSitePagesIsAllowed: this.state.TargetedSitePagesIsAllowed,

        // Targeted other
        TargetedVenueID: this.state.TargetedVenueID,
        TargetedVenueIDIsAllowed: this.state.TargetedVenueIDIsAllowed,
        TargetedCoppa: this.state.TargetedCoppa,

        // Targeted Custom
        TargetedCustom4: this.state.TargetedCustom4,
        TargetedCustom4IsAllowed: this.state.TargetedCustom4IsAllowed,
        TargetedCustom5: this.state.TargetedCustom5,
        TargetedCustom5IsAllowed: this.state.TargetedCustom5IsAllowed,
        TargetedCustom6: this.state.TargetedCustom6,
        TargetedCustom6IsAllowed: this.state.TargetedCustom6IsAllowed,
        TargetedCustom7: this.state.TargetedCustom7,
        TargetedCustom7IsAllowed: this.state.TargetedCustom7IsAllowed,
        TargetedCustom8: this.state.TargetedCustom8,
        TargetedCustom8IsAllowed: this.state.TargetedCustom8IsAllowed,
        TargetedCustom9: this.state.TargetedCustom9,
        TargetedCustom9IsAllowed: this.state.TargetedCustom9IsAllowed,
        TargetedCustom10: this.state.TargetedCustom10,
        TargetedCustom10IsAllowed: this.state.TargetedCustom10IsAllowed,
        TargetedCustom11: this.state.TargetedCustom11,
        TargetedCustom11IsAllowed: this.state.TargetedCustom11IsAllowed,
        TargetedCustom12: this.state.TargetedCustom12,
        TargetedCustom12IsAllowed: this.state.TargetedCustom12IsAllowed,
        TargetedCustom13: this.state.TargetedCustom13,
        TargetedCustom13IsAllowed: this.state.TargetedCustom13IsAllowed,
        TargetedCustom14: this.state.TargetedCustom14,
        TargetedCustom14IsAllowed: this.state.TargetedCustom14IsAllowed,
        TargetedCustom15: this.state.TargetedCustom15,
        TargetedCustom15IsAllowed: this.state.TargetedCustom15IsAllowed,
        TargetedCustom16: this.state.TargetedCustom16,
        TargetedCustom16IsAllowed: this.state.TargetedCustom16IsAllowed,
        TargetedCustom17: this.state.TargetedCustom17,
        TargetedCustom17IsAllowed: this.state.TargetedCustom17IsAllowed,
        TargetedCustom18: this.state.TargetedCustom18,
        TargetedCustom18IsAllowed: this.state.TargetedCustom18IsAllowed,
        TargetingAdomainExceptionState: this.state.TargetingAdomainExceptionState,

        //  Add Targeted Geo
        TargetingCountryGroupIDs: selectedCountryGroupItems
          .map((item: IListItem) => item.ID)
          .join(','),
        TargetingCountryGroupIDsIsAllowed: this.state.TargetingCountryGroupIDsIsAllowed,
        TargetingDeviceCountry: selectedCountries
          .map((item: IListItem) => item.ID.toUpperCase())
          .join(','),
        TargetingDeviceCountryIsAllowed: this.state.TargetingDeviceCountryIsAllowed,
        LocalTargetingAllowed: this.exportLocalTargetingParamToJSON(true),
        LocalTargetingDisallowed: this.exportLocalTargetingParamToJSON(false),
        CountryGroups: this.state.publisherCountryGroups,
        TargetingCCPA: this.state.TargetingCCPA,
      } as IBrandSafetyRule;

      // remove CreatedAt timestamp if it's brand new block rule
      if (rule.ID !== 0) {
        rule.CreatedAt = this.state.CreatedAt;
      }
      // save selected rule type (IAB, Adomain) object comma separated list
      if (this.state.ruleType === RuleTypeIAB) {
        rule.TargetedIABs = this.makeIABString();
        // if block_rule_type is IAB, overwrite the allowed_iab_categories list to empty
        rule.BrandSafetyRuleExceptions.forEach((_, idx: number) => {
          rule.BrandSafetyRuleExceptions[idx].AllowedIABCategories = '';
        });
      } else if (this.state.ruleType === RuleTypeAdomain) {
        rule.TargetedAdomains = this.makeAdomainString();
        // if block_rule_type is adomain, overwrite the allowed_adomains list to empty
        rule.BrandSafetyRuleExceptions.forEach((_, idx: number) => {
          rule.BrandSafetyRuleExceptions[idx].AllowedAdomains = '';
        });
        rule.TargetingAdomainExceptionState = this.state.TargetingAdomainExceptionState;
      } else if (this.state.ruleType === RuleTypeMediafile) {
        rule.TargetedMediafiles = this.makeMediafileDomainString();
      } else if (this.state.ruleType === RuleTypeCreativeID) {
        rule.TargetedCreativeIDs = this.makeCreativeIDString();
      } else if (this.state.ruleType === RuleTypeLanguage) {
        rule.TargetedLanguages = this.state.languages.join(',');
      } else if (this.state.ruleType === RuleTypeEventTracker) {
        rule.TargetedEventTrackers = this.state.eventTrackers.join('\t');
      }

      // validate rule
      const errorMessages: string[] = [
        ...validateLocalTargetingRule(
          this.state.localTargetingAllowedParameters,
          this.state.localTargetingDisallowedParameters,
        ),
      ];
      const ruleValidationErrorMessage = this.validateRule(
        rule,
        this.state.BrandSafetyRuleExceptions,
      );
      if (ruleValidationErrorMessage) {
        errorMessages.push(ruleValidationErrorMessage);
      }
      const errorMessage: string = errorMessages.join('; ');

      if (errorMessage) {
        this.setState({
          snackbarError: true,
          snackbarMessage: errorMessage,
        });
        return; // rule validation failed → stop here
      }
      // build request URL
      const reqURL =
        this.state.ID === 0
          ? createUrl('/brandsafetyrules', this.props.session.publisher.ID)
          : createUrl(`/brandsafetyrules/${this.state.ID}`, this.props.session.publisher.ID);
      // get the create or update request type
      const requestType = this.state.ID === 0 ? restPost : restPatch;
      const actionName = this.state.ID === 0 ? 'created' : 'updated';
      // make the request
      requestType<IBrandSafetyRule>(reqURL, rule)
        .then((val: IHttpResponse<IBrandSafetyRule>) => {
          const rule = val.parsedBody as IBrandSafetyRule;
          // OK
          this.setState(
            {
              snackbarError: false,
              snackbarMessage: `Rule "${rule.Name}" ${actionName}`,
              // if not defined (when creating), update the ID of the rule locally with the one from API
              ID: this.state.ID === 0 ? rule.ID : this.state.ID,
            },
            () => {
              if (actionName === 'created' && rule.ID) {
                setTimeout(() => {
                  navigate(
                    RouteBrandSafetyEdit,
                    extractRouteParams({
                      session: this.props.session,
                      user: this.props.user,
                    }),
                    { brandSafetyRuleID: rule.ID.toString() },
                  );
                }, 1000);
              }
            },
          );
        })
        .catch(() => {
          // error
          this.setState({
            snackbarError: true,
            snackbarMessage: `Error while creating the rule "${rule.Name}"`,
          });
        });
    }

    // validate a rule before saving it
    validateRule(
      rule: IBrandSafetyRule,
      originalExceptions: IBrandSafetyRuleException[],
    ): string | undefined {
      // if rule is not global, rule must target at least 1 channel/bidder (or group)
      if (
        rule.RuleTargetingType !== BrandSafetyRuleTargetingTypeGlobal &&
        rule.TargetedObjects.length === 0
      ) {
        const objectStr = targetingTypeToString(rule.RuleTargetingType);
        return `Error: the rule must target at least 1 ${objectStr}.`;
      }

      // rule must target at least 1 IAB or adomain or mediafile domain or language or creativeID or event tracker
      if (
        !rule.TargetedIABs &&
        !rule.TargetedAdomains &&
        !rule.TargetedMediafiles &&
        !rule.TargetedLanguages &&
        !rule.TargetedCreativeIDs &&
        !rule.TargetedEventTrackers
      ) {
        return `Error: the rule must target at least 1 IAB, Adomain, Mediafile domain, Creative ID, Event Tracker or Language`;
      }

      // every brand safety rule exception must target at least one headerbidder
      const invalidExceptionNames = [] as string[];
      if (originalExceptions.length > 0) {
        originalExceptions.forEach((exception) => {
          if (exception.BidderIDs === '') {
            invalidExceptionNames.push(`${exception.Name}`);
          }
        });
        if (invalidExceptionNames.length > 1) {
          return `Error: the exceptions ${invalidExceptionNames.join(
            ', ',
          )} must target at least 1 bidder.`;
        } else if (invalidExceptionNames.length === 1) {
          return `Error: the exception ${invalidExceptionNames[0]} must target at least 1 bidder.`;
        }
      }

      return undefined; // rule is valid
    }

    // creates the association table for the rule (table that targets channels/bidders IDs)
    CreateTargetedObjectsTable(): IBrandSafetyRuleAssociationTable[] {
      // get the targeted entry list
      let entryList = {} as IMenuList;
      switch (this.state.RuleTargetingType) {
        case BrandSafetyRuleTargetingTypeBidder:
          entryList = this.state.bidderList;
          break;
        case BrandSafetyRuleTargetingTypeBidderGroup:
          entryList = this.state.bidderGroupList;
          break;
        case BrandSafetyRuleTargetingTypeChannel:
          entryList = this.state.channelList;
          break;
        case BrandSafetyRuleTargetingTypeChannelGroup:
          entryList = this.state.channelGroupList;
          break;
        default:
          return []; // global or unknown → no association possible
      }
      // create list
      return Object.keys(entryList)
        .filter((k) => entryList[k].selected)
        .map((key: string) => {
          return {
            TargetingType: this.state.RuleTargetingType, // association table have same target type as the rule
            TargetID: Number(key), // targeted object (bidder, channel) ID
          } as IBrandSafetyRuleAssociationTable;
        });
    }

    // transforms the IAB selection into a comma-separated string
    // this function will also convert the list of included/excluded IAB codes to a list of included IAB codes
    // ex: "IAB1-1,IAB2-1"
    makeIABString(): string {
      return this.state.iabList
        .map((list: IIncludeExcludeTableElement) => {
          if (list.included) {
            return list.ID;
          }
          return '!' + list.ID;
        })
        .join(',');
    }

    // transforms the Adomain selection into a comma-separated string
    // ex: "google.com,facebook.com"
    makeAdomainString(): string {
      return this.state.adomain.join(',');
    }

    // transforms the Mediafile domain selection into a tab-separated string
    // ex: "google.com  facebook.com" or "google.com\tfacebook.com"
    makeMediafileDomainString(): string {
      return this.state.mediafiles.join('\t');
    }

    // transforms the creative ids selection into a comma-separated string
    // ex: "google.com,facebook.com,twitter.com"
    makeCreativeIDString(): string {
      return this.state.creativeIDs.join(',');
    }

    // handleRuleActiveSwitchChange handles changes in the rule's active switch
    handleRuleActiveSwitchChange = (checked: boolean) => {
      this.setState({
        Active: checked ? BrandSafetyRuleActiveActive : BrandSafetyRuleActiveInactive,
      });
    };

    handleChangeRuleTypeIABEntry(
      tab: number,
      newList: IIncludeExcludeTableElement[],
      title: string,
      idx?: number,
      disabled?: boolean,
    ) {
      if (disabled) {
        return;
      }
      if (isRuleTargetingTab(tab)) {
        // clonedBrandSafetyRuleExceptions refers to all of the items in the Exceptions Allow List
        const clonedBrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        for (let idx = 0; idx < clonedBrandSafetyRuleExceptions.length; idx++) {
          const brandSafetyRuleException = clonedBrandSafetyRuleExceptions[idx];
          const splitTargetedIABExceptions =
            brandSafetyRuleException.TargetedIABExceptions.split(',');
          const filteredTargetedIABExceptions = splitTargetedIABExceptions.filter(
            (targetedIABException) => targetedIABException !== title,
          );
          brandSafetyRuleException.TargetedIABExceptions = filteredTargetedIABExceptions.join(',');
        }

        const newTargetedIABs = this.state.TargetedIABs.split(',')
          .filter((targetedIAB) => targetedIAB !== '' && targetedIAB !== title)
          .join(',');

        this.setState({
          BrandSafetyRuleExceptions: clonedBrandSafetyRuleExceptions,
          TargetedIABs: newTargetedIABs,
          iabList: newList,
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedIABCategories = newList
            .map((list: IIncludeExcludeTableElement) => list.title)
            .join(',');
          this.setState({
            BrandSafetyRuleExceptions,
            iabListAllowed: newList,
          });
        }
      }
    }

    // returns true if the user is creating a new rule, false if it edit an existing one
    isNewRule(): boolean {
      return this.state.ID === 0;
    }

    // close the notification snackbar
    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    // handles the user click on the close button
    handleCloseButtonClick = () => {
      // if user is coming from the channel edit view (because of the channel's rule list), send it back to it
      if (this.props.session.brandSafetyReferrer === 'channel-edit') {
        window.history.back(); // return to the previous page
        return;
      }
      // else navigate to the brand safety rule list view
      this.navigateToRuleListView();
    };

    // navigate to the page listing all the rules
    navigateToRuleListView() {
      navigate(
        RouteBrandSafetyList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    }

    // handles the click on the delete rule button
    handleDeleteButtonClick = () => {
      this.setState({
        deletePopupActive: true,
      });
    };

    // executed when the delete dialog is hidden
    onHideDeleteDialog = () => {
      this.setState({
        deletePopupActive: false,
      });
    };

    // executed after rule deletion
    onDeleteDeleteDialog = () => {
      this.onHideDeleteDialog();
      this.navigateToRuleListView();
    };

    // handles click on rule targeting type chip (Global, Channel, Bidders ...)
    targetingTypeChangeHandler(newTargetedType: number) {
      this.setState({
        RuleTargetingType: newTargetedType,
      });
    }

    // handles click on rule type chip (IAB, Adomain)
    typeChangeHandler(newRuleType: number) {
      this.setState({
        ruleType: newRuleType,
      });
    }

    handleIABUserStringChange(
      ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      tab: number,
    ): void {
      const value = ev.target.value.split('-');
      if (value.length > 1 && value[1] === '') {
        value[1] = '-';
      }
      this.setState({
        [isRuleTargetingTab(tab) ? 'userEntryIABPrefix' : 'userEntryIABPrefixAllowed']:
          value[0].toUpperCase(),
        [isRuleTargetingTab(tab) ? 'userEntryIABSuffix' : 'userEntryIABSuffixAllowed']:
          (value.length > 1 ? value[1] : '').toUpperCase(),
      });
    }

    handleChangeList = (stateName: string) => {
      return (updatedMenuList: IMenuList) => {
        this.setState({
          [stateName]: updatedMenuList,
        });
      };
    };

    handleChipClick(chip: IEndpointBuilderChip): void {
      if (!chip.selected) {
        let newTargetingAdomainExceptionState =
          BrandSafetyRuleTargetingAdomainExceptionStateExactMatch;
        if (chip.text === 'Contains') {
          newTargetingAdomainExceptionState = BrandSafetyRuleTargetingAdomainExceptionStateContains;
        } else if (chip.text === 'Allow All') {
          newTargetingAdomainExceptionState = BrandSafetyRuleTargetingAdomainExceptionStateAllowAll;
        }
        const subtitle = [
          {
            text: 'Exact Match',
            selected: chip.text === 'Exact Match' ? true : false,
          },
          {
            text: 'Contains',
            selected: chip.text === 'Contains' ? true : false,
          },
          {
            text: 'Allow All',
            selected: chip.text === 'Allow All' ? true : false,
          },
        ];
        this.setState({
          subtitle,
          TargetingAdomainExceptionState: newTargetingAdomainExceptionState,
        });
      }
    }

    handleTypeTargetingExclusionChipClick(chip: IEndpointBuilderChip): void {
      if (!chip.selected) {
        if (chip.text === 'Block') {
          this.setState({
            IsTypeTargetingExcluded: true,
          });
        } else if (chip.text === 'Allow') {
          this.setState({
            IsTypeTargetingExcluded: false,
          });
        }
      }
    }

    setChipDefault(): void {
      const subtitle = [
        {
          text: 'Exact Match',
          selected: false,
        },
        {
          text: 'Contains',
          selected: false,
        },
        {
          text: 'Allow All',
          selected: false,
        },
      ];
      if (
        this.props.rule.TargetingAdomainExceptionState ===
        BrandSafetyRuleTargetingAdomainExceptionStateContains
      ) {
        subtitle[1].selected = true;
      } else if (
        this.props.rule.TargetingAdomainExceptionState ===
        BrandSafetyRuleTargetingAdomainExceptionStateAllowAll
      ) {
        subtitle[2].selected = true;
      } else {
        subtitle[0].selected = true;
      }
      this.setState({
        subtitle,
      });
    }

    // adds the Adomain user entry into the Adomain table
    addAdomainUserEntry(tab: number, idx?: number) {
      const adomain = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : this.state.adomainAllowed),
      ];
      const adomainUserEntry = (
        isRuleTargetingTab(tab) ? this.state.adomainUserEntry : this.state.adomainUserEntryAllowed
      ).toLowerCase();

      // check entry validity
      if (adomainUserEntry === '' || adomain.includes(adomainUserEntry)) {
        // user entry already exists in the list → error
        this.setState({
          snackbarError: true,
          snackbarMessage:
            adomainUserEntry === ''
              ? 'The adomain field is empty.'
              : `The adomain ${adomainUserEntry} already exists in the list.`,
          [isRuleTargetingTab(tab) ? 'adomainUserEntry' : 'adomainUserEntryAllowed']: '',
        });
        return;
      }

      // add user entry to table data array
      adomain.push(adomainUserEntry);
      // update state
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain,
          adomainUserEntry: '',
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomain.join(',');
          this.setState({
            adomainAllowed: adomain,
            adomainUserEntryAllowed: '',
            BrandSafetyRuleExceptions,
          });
        }
      }
    }

    digestAdomainCSVFile(ev: ProgressEvent<FileReader>, tab: number, idx?: number) {
      // initiate the adomainList that user is going to update depending on which tab user is on and the idx of rule_exception
      const adomainList = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : this.state.adomainAllowed),
      ];

      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      content.split('\n').forEach((line: string) => {
        // for each line
        line.split(',').forEach((entry: string) => {
          // for each CSV entry
          entry = entry.toLowerCase();
          entry = entry.replace('\r', '');
          // trim quotes (if any)
          if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
            entry = entry.substr(0, 1);
          }
          if (
            entry.length >= 1 &&
            (entry[entry.length - 1] === "'" || entry[entry.length - 1] === '"')
          ) {
            entry = entry.substr(entry.length - 1, 1);
          }
          // check if it's a valid adomain
          if (adomainRegexp.test(entry) && !adomainList.includes(entry)) {
            // valid domain, add it
            adomainList.push(entry);
          }
        });
      });
      // refresh state
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain: adomainList,
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomainList.join(',');
          this.setState({
            adomainAllowed: adomainList,
            BrandSafetyRuleExceptions,
          });
        }
      }
    }

    // gets the number of element targeted by a rule - also handle reverse targeting
    getRuleTargetNumber(
      ruleTargetingObjects: IBrandSafetyRuleAssociationTable[],
    ): number | undefined {
      // global targeting
      if (this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeGlobal) {
        return undefined;
      }
      // other targeting
      if (!this.state.IsTargetingExcluded) {
        // normal targeting
        return ruleTargetingObjects.length;
      } else {
        // reversed targeting
        // get number of existing targeted elements (ex: get the number of channels owned by this publisher)
        let totalNumberOfElement = 0;
        switch (this.state.RuleTargetingType) {
          case BrandSafetyRuleTargetingTypeChannel:
            totalNumberOfElement = Object.keys(this.state.channelList).length;
            break;
          case BrandSafetyRuleTargetingTypeChannelGroup:
            totalNumberOfElement = Object.keys(this.state.channelGroupList).length;
            break;
          case BrandSafetyRuleTargetingTypeBidder:
            totalNumberOfElement = Object.keys(this.state.bidderList).length;
            break;
          case BrandSafetyRuleTargetingTypeBidderGroup:
            totalNumberOfElement = Object.keys(this.state.bidderGroupList).length;
            break;
        }
        // subtract the number of targeted elements to the number of total elements
        return totalNumberOfElement - ruleTargetingObjects.length;
      }
    }

    // handles user's selected adomain CSV file
    handleAdomainCSVFile(target: EventTarget & HTMLInputElement, tab: number, idx?: number) {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestAdomainCSVFile(ev, tab, idx);
      fr.readAsText(file);
    }

    // adds the IAB user entry into the include/exclude table
    addIABUserEntry(tab: number, idx?: number) {
      const userSingleIABString = this.getUserSingleIABString(tab);
      const iabList = [
        ...(isRuleTargetingTab(tab) ? this.state.iabList : this.state.iabListAllowed),
      ];
      if (
        iabList.findIndex(
          (elem: IIncludeExcludeTableElement) => elem.ID === userSingleIABString,
        ) !== -1
      ) {
        // user single entry already exists in the table → error
        this.setState({
          snackbarError: true,
          snackbarMessage: `The IAB category ${userSingleIABString} already exists in the list.`,
          [isRuleTargetingTab(tab) ? 'userEntryIABPrefix' : 'userEntryIABPrefixAllowed']: '',
          [isRuleTargetingTab(tab) ? 'userEntryIABSuffix' : 'userEntryIABSuffixAllowed']: '',
        });
        return;
      }

      // insert user single entry
      let iabs: string[] = [userSingleIABString];
      // get user comma separated IAB list
      iabs = iabs.concat(
        (isRuleTargetingTab(tab) ? this.state.userEntryIABList : this.state.userEntryIABListAllowed)
          .toUpperCase()
          .split(',')
          .map((s: string) => s.trim()),
      );

      // remove bad strings from array
      iabs = iabs.filter((s: string) => iabRegexp.test(s));
      iabs.forEach((iab: string) => {
        if (iabList.findIndex((elem: IIncludeExcludeTableElement) => elem.ID === iab) === -1) {
          // if iab don't exist if, add it
          iabList.push({
            ID: iab,
            included: true,
            name: IABCategoryCodeToName(iab),
            title: iab,
          });
        }
      });
      // refresh the state and reset input fields
      if (isRuleTargetingTab(tab)) {
        this.setState({
          iabList,
          userEntryIABPrefix: '',
          userEntryIABSuffix: '',
          userEntryIABList: '',
          TargetedIABs: iabList.map((iabListItem) => iabListItem.title).join(','),
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedIABCategories = iabList
            .map((list: IIncludeExcludeTableElement) => list.title)
            .join(',');
          this.setState({
            BrandSafetyRuleExceptions,
            iabListAllowed: iabList,
            userEntryIABPrefixAllowed: '',
            userEntryIABSuffixAllowed: '',
            userEntryIABListAllowed: '',
          });
        }
      }
    }

    // gets the single IAB string entered by the user (via the IAB prefix and IAB suffix dropdowns)
    // ex: 'IAB1-2' or 'IAB1'
    getUserSingleIABString(tab: number): string {
      const userEntryIABPrefix = isRuleTargetingTab(tab)
        ? this.state.userEntryIABPrefix
        : this.state.userEntryIABPrefixAllowed;
      const userEntryIABSuffix = isRuleTargetingTab(tab)
        ? this.state.userEntryIABSuffix
        : this.state.userEntryIABSuffixAllowed;
      return (
        userEntryIABPrefix +
        (userEntryIABSuffix !== ''
          ? (userEntryIABSuffix !== '-' ? '-' : '') + userEntryIABSuffix
          : '')
      );
    }

    // handles click on the delete button in the adomain list table
    handleAdomainDelete(index: number, tab: number, idx?: number) {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain: update(this.state.adomain, { $splice: [[index, 1]] }),
        });
      } else {
        const adomainAllowed = cloneDeep(this.state.adomainAllowed);
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          adomainAllowed.splice(index, 1);
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomainAllowed.join(',');
          this.setState({
            adomainAllowed,
            BrandSafetyRuleExceptions,
          });
        }
      }
    }

    // ############################## RENDER RULE TYPE ADOMAIN TABLE ##############################
    renderAdomainTable(tab: number, idx?: number) {
      const adomain = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : this.state.adomainAllowed),
      ];
      return (
        <TableContainer component={Paper}>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {/* TABLE HEADERS*/}
                <TableCell>Adomain</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* TABLE CONTENT*/}
              {
                // for each list element
                adomain.map((adomain: string, index: number) => (
                  <TableRow>
                    {/* TITLE*/}
                    <TableCell>{adomain}</TableCell>

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        onClick={() => this.handleAdomainDelete(index, tab, idx)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    renderAdomainExceptionTable() {
      const { BrandSafetyRuleExceptions, openRuleTargetedExceptionDialogIABCode } = this.state;
      const renderAdomainSet = new Set<string>();
      for (const brandSafetyRuleException of BrandSafetyRuleExceptions) {
        const splitTargetedIABExceptions =
          brandSafetyRuleException.TargetedIABExceptions.split(',');
        const foundTargetedIABException =
          splitTargetedIABExceptions.find(
            (targetedIABException) =>
              targetedIABException === openRuleTargetedExceptionDialogIABCode,
          ) !== undefined;
        if (foundTargetedIABException) {
          const splitAllowedAdomains = brandSafetyRuleException.AllowedAdomains.split(',');
          for (const allowedAdomain of splitAllowedAdomains) {
            renderAdomainSet.add(allowedAdomain);
          }
        }
      }

      const renderAdomainArr = Array.from(renderAdomainSet);
      renderAdomainArr.sort();

      const listTableColumns: IListTableColumn[] = [
        { field: 'Adomain', title: 'Adomain', renderType: 'normal', searchable: true },
      ];

      const exceptionData = renderAdomainArr.map(
        (allowedAdomain: string, idx: number): IBrandSafetyRuleAdomainExceptionRowData => {
          return {
            Adomain: allowedAdomain,
            ID: idx,
            Name: allowedAdomain,
          };
        },
      );

      return (
        <ListTable
          title='Exceptions'
          columns={listTableColumns}
          data={exceptionData}
          handleSetUpdating={noopVoid}
        />
      );
    }

    // ############################## RENDER RULE TYPE ADOMAIN ENTRY COMPONENT ##############################
    renderRuleTypeAdomainEntry(
      tab: number,
      renderAllowAllOption: boolean,
      disabled: boolean,
      idx?: number,
    ) {
      const { classes } = this.props;
      return (
        <div style={{ marginLeft: 10 }}>
          {/* TABLE WITH LIST OF ADDED ADOMAIN*/}
          {this.state.TargetingAdomainExceptionState !==
            BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <div style={{ width: '450px', marginTop: '20px' }}>
              {this.renderAdomainTable(tab, idx)}
            </div>
          )}

          <div style={{ marginTop: '27px' }}>
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems='flex-start'
              spacing={1}
            >
              {this.state.subtitle.map((chipObject: IEndpointBuilderChip) => {
                if (
                  (chipObject.visible || chipObject.visible === undefined) &&
                  chipObject.text !== 'Allow All'
                ) {
                  return (
                    <Grid item>
                      <Chip
                        label={chipObject.text}
                        color={chipObject.selected ? 'primary' : 'default'}
                        onClick={() => {
                          this.handleChipClick(chipObject);
                        }}
                        style={{ marginBottom: 'unset', marginTop: 'unset' }}
                        disabled={false}
                        className={classes.chip}
                      />
                    </Grid>
                  );
                } else {
                  return (
                    renderAllowAllOption && (
                      <Grid item>
                        <Tooltip title='This includes bids with missing adomains'>
                          <Chip
                            label={chipObject.text}
                            color={chipObject.selected ? 'primary' : 'default'}
                            onClick={() => {
                              this.handleChipClick(chipObject);
                            }}
                            style={{ marginBottom: 'unset', marginTop: 'unset' }}
                            disabled={false}
                            className={classes.chip}
                          />
                        </Tooltip>
                      </Grid>
                    )
                  );
                }
              })}
            </Grid>
          </div>

          {/* TITLE*/}
          {this.state.TargetingAdomainExceptionState !==
            BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <div style={{ fontSize: '15px', marginTop: '10px' }}>
              Enter Adomain or upload a CSV. <br />
              {this.state.TargetingAdomainExceptionState ===
              BrandSafetyRuleTargetingAdomainExceptionStateExactMatch
                ? `Adomains will first be checked for an exact match. If the given adomain is plainly formatted, it will be checked against variations of the URL (i.e. ${getHelperText(
                    true,
                  )}, etc.)`
                : `With “contains”, please add keywords (i.e. ${getHelperText(false)}, etc.)`}
            </div>
          )}

          {/* FORM TO ADD ADOMAIN*/}
          {this.state.TargetingAdomainExceptionState !==
            BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <Grid container direction='row' justify='flex-start' alignItems='center' spacing={4}>
              {/* SINGLE USER ENTRY*/}
              <Grid item>
                <TextField
                  label='Adomain'
                  onKeyPress={(ev: React.KeyboardEvent) => {
                    if (ev && ev.key === 'Enter') {
                      this.addAdomainUserEntry(tab, idx); // add value when pressing enter
                    }
                  }}
                  placeholder={
                    this.state.TargetingAdomainExceptionState ===
                    BrandSafetyRuleTargetingAdomainExceptionStateExactMatch
                      ? 'ex: nike.com'
                      : 'ex: nike'
                  }
                  value={
                    isRuleTargetingTab(tab)
                      ? this.state.adomainUserEntry
                      : this.state.adomainUserEntryAllowed
                  }
                  onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                    this.setState({
                      [isRuleTargetingTab(tab) ? 'adomainUserEntry' : 'adomainUserEntryAllowed']:
                        target.value,
                    });
                  }}
                />
              </Grid>
              {/* ADD BUTTON*/}
              <Grid item style={{ marginTop: 16 }}>
                <ModelSecondaryButton
                  disabled={!!disabled}
                  onClick={() => {
                    this.addAdomainUserEntry(tab, idx);
                  }}
                >
                  + Add
                </ModelSecondaryButton>
              </Grid>

              <Grid item style={{ marginTop: '18px', fontSize: '17px', fontWeight: 500 }}>
                OR
              </Grid>

              {/* CSV UPLOAD*/}
              <Grid item style={{ marginTop: 16, marginLeft: '-7px' }}>
                <Button component='label'>
                  <BackupIcon />
                  &nbsp;&nbsp;&nbsp;&nbsp;Upload CSV
                  <input
                    type='file'
                    style={{ display: 'none', marginLeft: '20px' }}
                    accept='.csv'
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                      this.handleAdomainCSVFile(target, tab, idx)
                    }
                  />
                </Button>
              </Grid>
            </Grid>
          )}
        </div>
      );
    }

    // adds the MediafileUserEntry into the Mediafile table
    addMediafileUserEntry(tab: number) {
      const mediafiles = this.state.mediafiles;
      const mediafileUserEntry = this.state.mediafileUserEntry.toLowerCase();

      // check entry validity
      let snackbarMessage: string = '';
      if (mediafileUserEntry === '') {
        // user entry is empty → error
        snackbarMessage = 'The mediafile domain field is empty.';
      } else if (mediafiles.includes(mediafileUserEntry)) {
        // user entry already exists in mediafiles → error
        snackbarMessage = `The mediafile domain ${mediafileUserEntry} already exists in the list.`;
      } else if (!mediafileDomainRegexp.test(mediafileUserEntry)) {
        // user entry fails domain check → error
        snackbarMessage = 'The mediafile domain field is invalid.';
      }
      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add user entry to table data array
        mediafiles.push(mediafileUserEntry);
        // update state
        this.setState({
          mediafiles,
          mediafileUserEntry: '',
        });
      }
    }

    // handles click on the delete button in the language list table
    handleLanguageDelete(tab: number, index: number) {
      if (isRuleTargetingTab(tab)) {
        const languagesCopy = [...this.state.languages];
        languagesCopy.splice(index, 1);
        this.setState({
          languages: languagesCopy,
          languageList: getLanguagesAsIMenuList(languagesCopy),
        });
      }
    }

    // ############################## RENDER RULE TYPE LANGUAGE TABLE ##############################
    renderLanguageTable(tab: number) {
      const languages = this.state.languages;

      return (
        <TableContainer component={Paper}>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {/* TABLE HEADERS*/}
                <TableCell>Language</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* TABLE CONTENT*/}
              {
                // for each list element
                languages.map((language: string, index: number) => (
                  <TableRow>
                    {/* TITLE*/}
                    <TableCell>{language}</TableCell>

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        onClick={() => this.handleLanguageDelete(tab, index)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    renderTypeTargetingExclusionChips() {
      const { IsTypeTargetingExcluded } = this.state;
      const { classes } = this.props;

      const chips = [
        {
          text: 'Block',
          selected: IsTypeTargetingExcluded === true,
        },
        {
          text: 'Allow',
          selected: IsTypeTargetingExcluded === false,
        },
      ];

      return (
        <Cols gap='8px'>
          {chips.map((chip) => {
            return (
              <Col>
                <Chip
                  label={chip.text}
                  color={chip.selected ? 'primary' : 'default'}
                  onClick={() => this.handleTypeTargetingExclusionChipClick(chip)}
                  style={{ marginBottom: 'unset', marginTop: 'unset' }}
                  disabled={false}
                  className={classes.chip}
                />
              </Col>
            );
          })}
        </Cols>
      );
    }

    // ############################## RENDER RULE TYPE LANGUAGE ENTRY COMPONENT ##############################
    renderRuleTypeLanguageEntry(tab: number, disabled: boolean) {
      return (
        <Grid style={{ marginLeft: 10 }}>
          <Typography style={{ fontSize: 14, marginBottom: 5 }}>
            The language rule will only apply on channels where Eléa AI is enabled.
          </Typography>

          {this.renderTypeTargetingExclusionChips()}

          {/* TABLE WITH LIST OF ADDED ADOMAIN*/}
          <Grid style={{ width: '450px', marginTop: '20px' }}>{this.renderLanguageTable(tab)}</Grid>

          {/* TITLE*/}
          <Grid style={{ fontSize: '15px', marginTop: '30px' }}>
            Select Language
            <Tooltip
              title={'The language rule will only apply on channels where Eléa AI is enabled.'}
            >
              <InfoIcon
                style={{
                  verticalAlign: 'bottom',
                  width: '1rem',
                  color: '#929599',
                  marginLeft: '5px',
                }}
              />
            </Tooltip>
          </Grid>

          {/* FORM TO ADD LANGUAGE*/}
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems='center'
            spacing={4}
            style={{ marginTop: '-6px' }}
          >
            {/* LANGUAGE MULT-SELECT*/}
            <Grid item>
              <MaterialSearchDropdownMulti
                width='150px'
                fontSize='12px'
                menuTitle=''
                list={this.state.languageList}
                onChange={(list: IMenuList) => {
                  this.setState({
                    languageList: list,
                  });
                }}
                disabled={!!disabled}
                handleMenuAcceptClick={(list: IMenuList) => this.handleLanguageAcceptClick(list)}
                menuTitleOverride={' '}
                onlyShowNumberWhenClosed={true}
                maxHeight={350}
                selectAll={true}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    }

    handleLanguageAcceptClick(list: IMenuList): void {
      const selectedLanguages = [] as string[];

      for (const { selected, title } of Object.values(list)) {
        if (selected) {
          selectedLanguages.push(title);
        }
      }

      this.setState({
        languages: selectedLanguages,
      });
    }

    // handles user's selected adomain CSV file
    handleMediafileCSVFile(target: EventTarget & HTMLInputElement, tab: number) {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestMediafileCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestMediafileCSVFile(ev: ProgressEvent<FileReader>, tab: number) {
      const stateMediafiles = this.state.mediafiles;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const failedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        if (stateMediafiles.includes(entry)) {
          // duplicate domain
          duplicateEntries.push((idx + 1).toString());
        } else if (!mediafileDomainRegexp.test(entry)) {
          // invalid domain
          failedEntries.push((idx + 1).toString());
        } else {
          // valid domain
          acceptedEntries.push(entry);
        }
      });
      // used in snackbarMessage
      const listFailedEntries: string = failedEntries.join(', ');
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (failedEntries.length > 0 && duplicateEntries.length > 0) {
        snackbarMessage = `Entries ${listFailedEntries} in CSV file were invalid domain names.\nEntries ${listDuplicateEntries} in CSV file were duplicate domain names.`;
      } else if (failedEntries.length > 0) {
        snackbarMessage = `Entries ${listFailedEntries} in CSV file were invalid domain names.`;
      } else if (duplicateEntries.length > 0) {
        snackbarMessage = `Entries ${listDuplicateEntries} in CSV file were duplicate domain names.`;
      }

      // refresh state
      if (failedEntries.length > 0 || duplicateEntries.length > 0) {
        const mediafiles = stateMediafiles;
        this.setState({
          mediafiles,
          snackbarError: true,
          snackbarMessage,
          mediafileUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        const mediafiles = stateMediafiles.concat(acceptedEntries);
        this.setState({
          mediafiles,
        });
      }
    }

    // handles click on the delete button in the mediafiles list table
    handleMediafileDelete(index: number, tab: number) {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          mediafiles: update(this.state.mediafiles, { $splice: [[index, 1]] }),
        });
      }
    }

    // ############################## RENDER RULE TYPE MEDIAFILE TABLE ##############################
    renderMediafileTable(tab: number) {
      const mediafiles = this.state.mediafiles;
      return (
        <TableContainer component={Paper}>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {/* TABLE HEADERS*/}
                <TableCell>Mediafile</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* TABLE CONTENT*/}
              {
                // for each list element
                mediafiles.map((mediafile: string, index: number) => (
                  <TableRow>
                    {/* TITLE*/}
                    <TableCell>{mediafile}</TableCell>

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        onClick={() => this.handleMediafileDelete(index, tab)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE MEDIAFILE ENTRY COMPONENT ##############################
    renderRuleTypeMediafileEntry(tab: number, disabled: boolean) {
      return (
        <div style={{ marginLeft: 10 }}>
          {/* TABLE WITH LIST OF ADDED MEDIAFILES*/}
          <div style={{ width: '890px', marginTop: '20px' }}>{this.renderMediafileTable(tab)}</div>

          {/* TITLE*/}
          <div style={{ fontSize: '15px', marginTop: '27px' }}>
            Enter Mediafile domain (with optional path). Mediafile domains will first be checked for
            an exact match. If the given mediafile domain is plainly formatted, it will be checked
            against variations of the URL (i.e. getpublica.com matches with
            https://getpublica.com/mediafile.mp4, http://getpublica.com/path/to/mediafile.mp4, etc.)
          </div>

          {/* FORM TO ADD MEDIAFILE*/}
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={4}>
            {/* SINGLE USER ENTRY*/}
            <Grid item>
              <TextField
                label='Mediafile'
                onKeyPress={(ev: React.KeyboardEvent) => {
                  if (ev && ev.key === 'Enter') {
                    this.addMediafileUserEntry(tab); // add value when pressing enter
                  }
                }}
                placeholder='ex: nike.com'
                value={this.state.mediafileUserEntry}
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  this.setState({
                    mediafileUserEntry: target.value,
                  });
                }}
              />
            </Grid>

            {/* ADD BUTTON*/}
            <Grid item style={{ marginTop: 16 }}>
              <ModelSecondaryButton
                disabled={!!disabled}
                onClick={() => {
                  this.addMediafileUserEntry(tab);
                }}
              >
                + Add
              </ModelSecondaryButton>
            </Grid>

            <Grid item style={{ marginTop: '18px', fontSize: '17px', fontWeight: 500 }}>
              OR
            </Grid>

            {/* CSV UPLOAD*/}
            <Grid item style={{ marginTop: '10px', marginLeft: '-7px' }}>
              <Grid container direction='column'>
                <Grid item>
                  <div style={{ fontSize: '15px', marginTop: '27px' }}>
                    Upload a CSV file with all entries in column A.
                  </div>
                </Grid>
                <Grid item>
                  <Button component='label'>
                    <BackupIcon />
                    &nbsp;&nbsp;&nbsp;&nbsp;Upload CSV
                    <input
                      type='file'
                      style={{ display: 'none', marginLeft: '20px' }}
                      accept='.csv'
                      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                        this.handleMediafileCSVFile(target, tab)
                      }
                    />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }

    // adds the creativeIDEntry into the creative ids table
    addCreativeIDUserEntry(tab: number) {
      const creativeIDs = this.state.creativeIDs;
      const creativeIDUserEntry = this.state.creativeIDUserEntry.toLowerCase();

      // check entry validity
      let snackbarMessage: string = '';
      if (creativeIDUserEntry === '') {
        // user entry is empty → error
        snackbarMessage = 'The creative ID field is empty.';
      } else if (creativeIDs.includes(creativeIDUserEntry)) {
        // user entry already exists in creative ids → error
        snackbarMessage = `The creative ID ${creativeIDUserEntry} already exists in the list.`;
      }
      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add user entry to table data array
        creativeIDs.push(creativeIDUserEntry);
        // update state
        this.setState({
          creativeIDs,
          creativeIDUserEntry: '',
        });
      }
    }

    // handles user's selected creative ids CSV file
    handleCreativeIDCSVFile(target: EventTarget & HTMLInputElement, tab: number) {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestCreativeIDCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestCreativeIDCSVFile(ev: ProgressEvent<FileReader>, tab: number) {
      const stateCreativeIDs = this.state.creativeIDs;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        if (stateCreativeIDs.includes(entry)) {
          // duplicate creative id
          duplicateEntries.push((idx + 1).toString());
        } else {
          // valid creative
          acceptedEntries.push(entry);
        }
      });
      // used in snackbarMessage
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (duplicateEntries.length > 0) {
        snackbarMessage = `Entries ${listDuplicateEntries} in CSV file were duplicate domain names.`;
      }

      // refresh state
      if (duplicateEntries.length > 0) {
        const creativeIDs = stateCreativeIDs;
        this.setState({
          creativeIDs,
          snackbarError: true,
          snackbarMessage,
          creativeIDUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        const creativeIDs = stateCreativeIDs.concat(acceptedEntries);
        this.setState({
          creativeIDs,
        });
      }
    }

    // handles click on the delete button in the creativeID list table
    handleCreativeIDDelete(index: number, tab: number) {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          creativeIDs: update(this.state.creativeIDs, { $splice: [[index, 1]] }),
        });
      }
    }

    // ############################## RENDER RULE TYPE CREATIVEID TABLE ##############################
    renderCreativeIDTable(tab: number) {
      const creativeIDs = this.state.creativeIDs;
      return (
        <TableContainer component={Paper}>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {/* TABLE HEADERS*/}
                <TableCell>Creative ID</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* TABLE CONTENT*/}
              {
                // for each list element
                creativeIDs.map((creativeIDs: string, index: number) => (
                  <TableRow>
                    {/* TITLE*/}
                    <TableCell>{creativeIDs}</TableCell>

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        onClick={() => this.handleCreativeIDDelete(index, tab)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE CREATIVE ID ENTRY COMPONENT ##############################
    renderRuleTypeCreativeIDEntry(tab: number, disabled: boolean, idx?: number) {
      return (
        <Panel>
          <Rows>
            {/* TABLE WITH LIST OF ADDED CREATIVE IDS*/}
            <Row style={{ maxWidth: '600px' }}>{this.renderCreativeIDTable(tab)}</Row>

            <Row paddingLeft={spacing.none}>
              <Text style={{ fontSize: '15px', fontFamily: 'inherit' }}>
                Enter Creative ID or upload a CSV. <br />
                Creative ID will be checked for an exact match.
              </Text>
            </Row>
            <Row paddingLeft={spacing.none} style={{ alignItems: 'center' }}>
              <Cols style={{ alignItems: 'center' }}>
                <Col paddingRight={spacing.extraLarge}>
                  <TextField
                    label='Creative ID'
                    onKeyPress={(ev: React.KeyboardEvent) => {
                      if (ev && ev.key === 'Enter') {
                        this.addCreativeIDUserEntry(tab); // add value when pressing enter
                      }
                    }}
                    placeholder={'ex: 123ABC'}
                    value={this.state.creativeIDUserEntry}
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                      this.setState({
                        ['creativeIDUserEntry']: target.value,
                      });
                    }}
                  />
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <ModelSecondaryButton
                    disabled={!!disabled}
                    onClick={() => {
                      this.addCreativeIDUserEntry(tab);
                    }}
                  >
                    + Add
                  </ModelSecondaryButton>
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <Text bold>OR</Text>
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <Cols style={{ alignItems: 'center' }}>
                    <Button component='label'>
                      <Col paddingTop={spacing.extraSmall}>
                        <BackupIcon />
                      </Col>
                      <Col paddingLeft={spacing.medium}>Upload CSV</Col>
                      <input
                        type='file'
                        style={{ display: 'none', marginLeft: '20px' }}
                        accept='.csv'
                        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                          this.handleAdomainCSVFile(target, tab, idx)
                        }
                      />
                    </Button>
                  </Cols>
                </Col>
              </Cols>
            </Row>
          </Rows>
        </Panel>
      );
    }

    // adds the eventTrackerDEntry into the event trackers table
    addEventTrackerUserEntry(tab: number) {
      const eventTrackers = [...this.state.eventTrackers];
      let eventTrackerUserEntry = this.state.eventTrackerUserEntry.toLowerCase();
      eventTrackerUserEntry = getDomain(eventTrackerUserEntry);
      // check entry validity
      let snackbarMessage: string = '';
      if (eventTrackerUserEntry.length === 0) {
        // user entry is empty → error
        snackbarMessage = 'The event tracker field is empty.';
      } else if (eventTrackers.includes(eventTrackerUserEntry)) {
        // user entry already exists in event trackers → error
        snackbarMessage = `The event tracker ${eventTrackerUserEntry} domain already exists in the list.`;
      } else if (!mediafileDomainRegexp.test(eventTrackerUserEntry)) {
        // user entry fails event tracker check → error
        snackbarMessage = 'The event tracker domain field is invalid.';
      }
      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add entry to table data array
        eventTrackers.push(eventTrackerUserEntry);
        // update state
        this.setState({
          eventTrackers,
          eventTrackerUserEntry: '',
        });
      }
    }

    // handles click on the delete button in the event tracker list table
    handleEventTrackerDelete(index: number, tab: number) {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          eventTrackers: update(this.state.eventTrackers, { $splice: [[index, 1]] }),
        });
      }
    }

    // handles user's selected event trackers CSV file
    handleEventTrackerCSVFile(target: EventTarget & HTMLInputElement, tab: number) {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestEventTrackerCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestEventTrackerCSVFile(ev: ProgressEvent<FileReader>, tab: number) {
      const stateEventTrackers = this.state.eventTrackers;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const failedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        entry = getDomain(entry);
        if (stateEventTrackers.includes(entry)) {
          // duplicate creative id
          duplicateEntries.push((idx + 1).toString());
        } else if (!mediafileDomainRegexp.test(entry)) {
          // invalid event tracker
          failedEntries.push((idx + 1).toString());
        } else {
          // valid creative
          acceptedEntries.push(entry);
        }
      });

      // used in snackbarMessage
      const listFailedEntries: string = failedEntries.join(', ');
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (failedEntries.length > 0 && duplicateEntries.length > 0) {
        snackbarMessage = `Entries ${listFailedEntries} in CSV file were invalid event trackers.\nEntries ${listDuplicateEntries} in CSV file were duplicate event trackers.`;
      } else if (failedEntries.length > 0) {
        snackbarMessage = `Entries ${listFailedEntries} in CSV file were invalid event trackers.`;
      } else if (duplicateEntries.length > 0) {
        snackbarMessage = `Entries ${listDuplicateEntries} in CSV file were duplicate event trackers.`;
      }

      // refresh state
      if (failedEntries.length > 0 || duplicateEntries.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
          creativeIDUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        this.setState({
          eventTrackers: stateEventTrackers.concat(acceptedEntries),
        });
      }
    }

    // ############################## RENDER RULE TYPE EVENTTRACKER TABLE ##############################
    renderEventTrackerTable(tab: number) {
      return (
        <TableContainer component={Paper}>
          <Table size={'small'}>
            <TableHead>
              <TableRow>
                {/* TABLE HEADERS*/}
                <TableCell>Event Tracker</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* TABLE CONTENT*/}
              {
                // for each list element
                this.state.eventTrackers.map((eventTracker: string, index: number) => (
                  <TableRow>
                    {/* TITLE*/}
                    <TableCell>{eventTracker}</TableCell>

                    {/* DELETE BUTTON*/}
                    <TableCell>
                      <IconButton
                        onClick={() => this.handleEventTrackerDelete(index, tab)}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE EVENT TRACKER ENTRY COMPONENT ##############################
    renderRuleTypeEventTrackerEntry(tab: number, disabled: boolean) {
      return (
        <Panel>
          <Rows>
            {/* TABLE WITH LIST OF ADDED EVENT TRACKERS*/}
            <Row style={{ maxWidth: '600px' }}>{this.renderEventTrackerTable(tab)}</Row>

            <Row paddingLeft={spacing.none}>
              <Text style={{ fontSize: '15px', fontFamily: 'inherit' }}>
                Enter Event Tracker or upload a CSV. <br />
                Event Trackers will be checked against the domain.
              </Text>
            </Row>
            <Row paddingLeft={spacing.none} style={{ alignItems: 'center' }}>
              <Cols style={{ alignItems: 'center' }}>
                <Col paddingRight={spacing.extraLarge}>
                  <TextField
                    label='Event Tracker'
                    onKeyPress={(ev: React.KeyboardEvent) => {
                      if (ev && ev.key === 'Enter') {
                        this.addEventTrackerUserEntry(tab); // add value when pressing enter
                      }
                    }}
                    placeholder={'ex: 123ABC'}
                    value={this.state.eventTrackerUserEntry}
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                      this.setState({
                        eventTrackerUserEntry: target.value,
                      });
                    }}
                  />
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <ModelSecondaryButton
                    disabled={!!disabled}
                    onClick={() => {
                      this.addEventTrackerUserEntry(tab);
                    }}
                  >
                    + Add
                  </ModelSecondaryButton>
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <Text bold>OR</Text>
                </Col>
                <Col paddingRight={spacing.extraLarge}>
                  <Cols style={{ alignItems: 'center' }}>
                    <Button component='label'>
                      <Col paddingTop={spacing.extraSmall}>
                        <BackupIcon />
                      </Col>
                      <Col paddingLeft={spacing.medium}>Upload CSV</Col>
                      <input
                        type='file'
                        style={{ display: 'none', marginLeft: '20px' }}
                        accept='.csv'
                        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                          this.handleEventTrackerCSVFile(target, tab)
                        }
                      />
                    </Button>
                  </Cols>
                </Col>
              </Cols>
            </Row>
          </Rows>
        </Panel>
      );
    }

    // ############################## RENDER RULE TYPE IAB ENTRY COMPONENT ##############################
    renderRuleTypeIABEntry(tab: number, disabled?: boolean, idx?: number) {
      const iabList = isRuleTargetingTab(tab) ? this.state.iabList : this.state.iabListAllowed;
      return (
        <div style={{ marginLeft: 10 }}>
          {/* TABLE WITH INCLUDE/EXCLUDE*/}
          <div style={{ width: '450px', marginTop: '20px' }}>
            <IncludeExcludeTable
              source={SourceBrandSafetyRuleEdit}
              list={iabList}
              brandSafetyRuleExceptions={this.state.BrandSafetyRuleExceptions}
              statusChangeDisabled={tab === RuleExceptionTab}
              handleChange={(newList: IIncludeExcludeTableElement[], title: string) =>
                this.handleChangeRuleTypeIABEntry(tab, newList, title, idx, disabled)
              }
              elementTitleHeader='IAB Code'
              elementNameHeader='IAB Category'
              handleOpenRuleTargetedExceptionDialog={(targetedExceptionIABCode: string) =>
                this.handleOpenRuleTargetedExceptionDialog(targetedExceptionIABCode)
              }
              parentClassName='brandsafety'
            />
          </div>

          <Grid container direction='row' alignItems='flex-end' spacing={4}>
            <Grid item>
              {/* Enter IAB */}
              <Grid container direction='column'>
                <Grid item>
                  <div style={{ fontSize: '15px', marginTop: '27px' }}>
                    Enter IAB Category or Subcategory
                  </div>
                </Grid>
                <Grid item>
                  <Grid container direction='row' alignItems='center'>
                    <Grid item style={{ width: 80, marginTop: 16 }}>
                      <TextField
                        disabled={!!disabled}
                        name='IAB Cat'
                        fullWidth
                        placeholder='ex: IAB1-2'
                        onKeyPress={(ev: React.KeyboardEvent) => {
                          if (ev && ev.key === 'Enter') {
                            this.addIABUserEntry(tab, idx); // add value when pressing enter
                          }
                        }}
                        value={this.getUserSingleIABString(tab)}
                        onChange={(ev) => this.handleIABUserStringChange(ev, tab)}
                      />
                    </Grid>

                    {/* IAB CAT PREFIX ONLY*/}
                    <Grid
                      item
                      style={{
                        marginLeft: 10,
                        marginTop: 16,
                        width: '250px',
                      }}
                    >
                      <Select
                        style={{
                          width: 250,
                        }}
                        disabled={!!disabled}
                        value={
                          isRuleTargetingTab(tab)
                            ? this.state.userEntryIABPrefix
                            : this.state.userEntryIABPrefixAllowed
                        }
                        onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                          this.setState({
                            [isRuleTargetingTab(tab)
                              ? 'userEntryIABPrefix'
                              : 'userEntryIABPrefixAllowed']: ev.target.value as string,
                          });
                        }}
                        className='iab-category-prefix-select'
                      >
                        {getAllIABCategories().map((val) => {
                          return (
                            <MenuItem value={val}>
                              {val}: {IAB_CATEGORIES[val].label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid>
                    {/* IAB SUFFIX ONLY*/}
                    {(this.state.userEntryIABPrefix !== '' ||
                      this.state.userEntryIABPrefixAllowed !== '') && (
                      <Grid
                        item
                        style={{
                          marginLeft: 10,
                          width: '250px',
                          marginTop: 16,
                        }}
                      >
                        <Select
                          style={{
                            width: '250px',
                          }}
                          disabled={!!disabled}
                          value={
                            isRuleTargetingTab(tab)
                              ? this.state.userEntryIABSuffix
                              : this.state.userEntryIABSuffixAllowed
                          }
                          onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                            this.setState({
                              [isRuleTargetingTab(tab)
                                ? 'userEntryIABSuffix'
                                : 'userEntryIABSuffixAllowed']: ev.target.value as string,
                            });
                          }}
                          className='iab-category-suffix-select'
                        >
                          {Object.keys(
                            (
                              IAB_CATEGORIES[
                                isRuleTargetingTab(tab)
                                  ? this.state.userEntryIABPrefix
                                  : this.state.userEntryIABPrefixAllowed
                              ] || { values: [] }
                            ).values || {},
                          ).map((val) => {
                            return (
                              <MenuItem value={val}>
                                {val}:{' '}
                                {
                                  IAB_CATEGORIES[
                                    isRuleTargetingTab(tab)
                                      ? this.state.userEntryIABPrefix
                                      : this.state.userEntryIABPrefixAllowed
                                  ].values[val]
                                }
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* OR */}
            <Grid item>
              <div style={{ marginTop: '18px', fontSize: '17px', fontWeight: 500 }}>OR</div>
            </Grid>
            {/* IAB Comma Separated */}
            <Grid item style={{ marginTop: '-2px', width: '300px' }}>
              <TextField
                style={{ width: 260 }}
                disabled={!!disabled}
                name='IABCatCommaSeparated'
                label='IAB Cat Separated by comma'
                value={
                  isRuleTargetingTab(tab)
                    ? this.state.userEntryIABList
                    : this.state.userEntryIABListAllowed
                }
                onKeyPress={(ev: React.KeyboardEvent) => {
                  if (ev && ev.key === 'Enter') {
                    this.addIABUserEntry(tab, idx); // add value when pressing enter
                  }
                }}
                placeholder='ex: IAB1-1,IAB1-2,IAB2,IAB3'
                onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                  this.setState({
                    [isRuleTargetingTab(tab) ? 'userEntryIABList' : 'userEntryIABListAllowed']: ev
                      .target.value as string,
                  });
                }}
              />
            </Grid>
            {/* Add */}
            <Grid item>
              <ModelSecondaryButton
                disabled={!!disabled}
                onClick={() => {
                  this.addIABUserEntry(tab, idx);
                }}
              >
                + Add
              </ModelSecondaryButton>
            </Grid>
          </Grid>
        </div>
      );
    }

    // return a promise that deletes a rule in the API
    deleteRuleWithPromise(ruleID: number) {
      // build request URL
      const reqURL = createUrl(`/brandsafetyrules/${ruleID}`, this.props.session.publisher.ID);
      // return the request's promise
      return restDelete<IBrandSafetyRule>(reqURL, null);
    }

    // returns the type name of the rule targeting (ex: 'bidder' or 'channel')
    getTargetingTypeName(): string {
      switch (this.state.RuleTargetingType) {
        case BrandSafetyRuleTargetingTypeBidder:
          return 'bidder';
        case BrandSafetyRuleTargetingTypeBidderGroup:
          return 'bidder group';
        case BrandSafetyRuleTargetingTypeChannel:
          return 'channel';
        case BrandSafetyRuleTargetingTypeChannelGroup:
          return 'channel group';
        case BrandSafetyRuleTargetingTypeGlobal:
          return 'global';
      }
      return 'unknown';
    }

    // generates the active tags for comma sep values for the accordions (i.e. 2 IDs, 4 Producers)
    // fieldValue represents the textfield (contentid1, contentid2, contentid3) and
    // fieldName represents the name to be shown (Content ID)
    // multi-accordion-panel will ignore an empty string active tag
    generateActiveTagForCommaSepField = (fieldValue: string, fieldName: string) => {
      if (fieldValue && fieldValue.length > 0) {
        // split the field and get rid of empty strings to count
        const count = fieldValue.split(',').filter((part: string) => part !== '').length;
        return count === 1 ? `1 ${fieldName}` : `${count} ${fieldName}s`;
      }
      return '';
    };

    // display a the list of string if result string is below maxStrLength characters
    // else display the number of elements instead
    truncateListIfTooLong(list: string[], maxStrLength: number, name: string): string {
      const listAsStr = list.join(', ');
      if (listAsStr.length > maxStrLength) {
        // string is too long, return number of elements
        return `${list.length} ${name}` + (list.length > 1 ? 's' : '');
      }
      // string length is okay, return it
      return listAsStr;
    }

    // ############################## RENDER IAB SUMMARY FOR RULE SUMMARY ##############################
    renderIABSummary() {
      return (
        <>
          {/* BLOCKED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={1}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Blocked
            </Grid>
            <Grid item style={{ marginBottom: 15 }}>
              {
                // print list of blocked IAB
                this.truncateListIfTooLong(
                  this.state.iabList.filter((e) => e.included).map((e) => e.title),
                  23,
                  'IAB',
                )
              }
            </Grid>
          </Grid>
          {/* ALLOWED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={1}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Allowed
            </Grid>
            <Grid item>
              {
                // print list of blocked IAB
                this.truncateListIfTooLong(
                  this.state.iabList.filter((e) => !e.included).map((e) => e.title),
                  23,
                  'IAB',
                )
              }
            </Grid>
          </Grid>
        </>
      );
    }

    // ############################## RENDER ADOMAIN SUMMARY FOR RULE SUMMARY ##############################
    renderAdomainSummary() {
      return (
        <>
          {/* BLOCKED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={3}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Blocked
            </Grid>
            <Grid item>
              {
                // print list of blocked adomains
                this.truncateListIfTooLong(this.state.adomain, 23, 'adomain')
              }
            </Grid>
          </Grid>
        </>
      );
    }

    renderMediafileSummary() {
      return (
        <>
          {/* BLOCKED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={3}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Blocked
            </Grid>
            <Grid item>
              {
                // print list of blocked adomains
                this.truncateListIfTooLong(this.state.mediafiles, 23, 'mediafile')
              }
            </Grid>
          </Grid>
        </>
      );
    }

    renderCreativeIDSummary() {
      return (
        <>
          {/* BLOCKED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={3}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Blocked
            </Grid>
            <Grid item>
              {
                // print list of blocked creative ids
                this.truncateListIfTooLong(this.state.creativeIDs, 23, 'creativeID')
              }
            </Grid>
          </Grid>
        </>
      );
    }

    // ############################## RENDER RULE SUMMARY FLOATING ELEMENT ##############################
    renderRuleSummary() {
      const ruleTargetingObjects = this.CreateTargetedObjectsTable();
      return (
        <Grid
          style={{
            backgroundColor: '#F5F5F5',
            width: '100%',
            height: '100%',
            padding: '15px',
          }}
        >
          {/* TITLE*/}
          <Typography
            style={{
              marginTop: 0,
              marginBottom: 0,
              fontWeight: 700,
              fontSize: '17px',
              color: publicaColors.darkGray,
            }}
          >
            Summary
          </Typography>

          {/* SUBTITLE*/}
          <p
            style={{
              color: 'gray',
              marginTop: '0px',
              fontSize: '12px',
            }}
          >
            Your current rule selection will impact the following:
          </p>

          {/* TARGETING DESCRIPTION*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={1}
          >
            <Grid item>
              <b style={{ color: publicaColors.darkGray }}>
                {toTitleCase(this.getTargetingTypeName()) +
                  (ruleTargetingObjects.length < 2 ? '' : 's')}
              </b>
            </Grid>
            <Grid item>{this.getRuleTargetNumber(ruleTargetingObjects)}</Grid>
          </Grid>

          {/* IAB/ADOMAIN DESCRIPTION*/}
          <Grid style={{ marginTop: '18px' }}>
            {this.state.ruleType === RuleTypeIAB && (
              <>
                <b>IAB Category</b>
                {this.renderIABSummary()}
              </>
            )}
            {this.state.ruleType === RuleTypeAdomain && (
              <>
                <b>Adomain</b>
                {this.renderAdomainSummary()}
              </>
            )}
            {this.state.ruleType === RuleTypeMediafile && (
              <>
                <b>Mediafile</b>
                {this.renderMediafileSummary()}
              </>
            )}
            {this.state.ruleType === RuleTypeCreativeID && (
              <>
                <b>Creative ID</b>
                {this.renderCreativeIDSummary()}
              </>
            )}
          </Grid>
        </Grid>
      );
    }

    renderBrandSafetyRuleTargeting = (): ReactElement => {
      const { hasWriteCurrentRuleRight, RuleTargetingType } = this.state;
      // App Panel & Rows
      const appBundleRow = {
        renderType: 'TextfieldAndInclude',
        title1: 'App Bundle ID',
        field1: 'TargetedAppBundleID',
        value1: this.state.TargetedAppBundleID,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetedAppBundleID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedAppBundleID, 'App Bundle ID'),
        value2: this.state.TargetedAppBundleIDIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedAppBundleIDIsAllowed',
              value:
                this.state.TargetedAppBundleIDIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as React.ChangeEvent<HTMLInputElement>),
        placeholderText: 'Enter App Bundle IDs here, comma separated',
        tooltipText: (
          <div>
            App Bundle ID to bid on
            <br />- Android: com.hulu.plus
            <br />- Apple TV: 482066631
            <br />- Roku: 12
            <br />- Fire TV: B004U7BXBO
            <br />- Samsung: G15115002089
            <br /> More info{' '}
            <a
              href='https://iabtechlab.com/wp-content/uploads/2020/08/IAB-Tech-Lab-OTT-store-assigned-App-Identification-Guidelines-2020.pdf'
              rel='noopener'
              target='_blank'
            >
              here
            </a>
          </div>
        ),
      } as IInputRow;

      const sitePagesRow = {
        renderType: 'TextfieldAndInclude',
        title1: 'Site Page',
        field1: 'TargetedSitePages',
        value1: this.state.TargetedSitePages,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetedSitePages.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedSitePages, 'Site Page'),
        value2: this.state.TargetedSitePagesIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedSitePagesIsAllowed',
              value:
                this.state.TargetedSitePagesIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        placeholderText: 'Enter Site Pages here, comma separated',
      } as IInputRow;

      const AppPanel = {
        title: 'App',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'App',
        rows: [appBundleRow, sitePagesRow],
      };

      // Content Panel & Rows
      const contentAccordionRows = [
        'Channel',
        'Distributor',
        'Genre',
        'ID',
        'Network',
        'Producer',
        'Rating',
        'Series',
        'Title',
      ].map((fieldName: string) => {
        const contentFieldName = `TargetedContent${fieldName}`;
        const contentFieldIsAllowedName = `TargetedContent${fieldName}IsAllowed`;
        const contentFieldIsAllowed = this.state[contentFieldIsAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndInclude',
          tooltipText: `Content ${fieldName} to apply on, can be comma separated`,
          title1: `Content ${fieldName}`,
          field1: contentFieldName,
          value1: this.state[contentFieldName],
          handleChange1: this.handleChange,
          isActiveValue1: () => this.state[contentFieldName].length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(this.state[contentFieldName], fieldName),
          value2: contentFieldIsAllowed,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: contentFieldIsAllowedName,
                value:
                  this.state[contentFieldIsAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: `Enter Content ${fieldName} to be applied on here, comma separated`,
        } as IInputRow;
      });
      const ContentPanel = {
        title: 'Content',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: [...contentAccordionRows],
      } as IAccordionPanel;

      // Custom Panel & Rows (also known as customRows in other places such as Campaign and Bidder)
      const customAccordionRows = [
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
      ].map((fieldName: string) => {
        const customFieldName = `TargetedCustom${fieldName}`;
        const customFieldIsAllowedName = `TargetedCustom${fieldName}IsAllowed`;
        const customFieldIsAllowed = this.state[customFieldIsAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndInclude',
          tooltipText: `Custom ${fieldName} to apply on, can be comma separated`,
          title1: `Custom ${fieldName}`,
          field1: customFieldName,
          value1: this.state[customFieldName],
          handleChange1: this.handleChange,
          isActiveValue1: () => this.state[customFieldName].length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(
              this.state[customFieldName],
              `Custom ${fieldName}`,
            ),
          value2: customFieldIsAllowed,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: customFieldIsAllowedName,
                value:
                  this.state[customFieldIsAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: `Enter Custom ${fieldName} to be applied on here, comma separated`,
          optionalIcon: fieldName === 'Targeting' ? 'flag' : null,
          optionalIconInfo: fieldName === 'Targeting' ? 'Not included in forecast' : null,
        } as IInputRow;
      });
      const CustomPanel = {
        title: 'Custom',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: [...customAccordionRows],
      } as IAccordionPanel;

      // GEO PANEL AND ROWS
      const countriesCount = Object.values(this.state.targetingCountriesList).filter(
        (item: IListItem) => item.selected,
      ).length;
      const countryGroupCount = Object.values(this.state.targetingCountryGroupList).filter(
        (item: IListItem) => item.selected,
      ).length;
      const TargetedRegionsRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderAllRegionsDialog({
            renderType: 'MaterialDropdown',
            title1: 'Targeted Regions',
            field1: 'TargetingCountryGroupIDs',
            value1: this.state.targetingCountryGroupList,
            handleChange1: this.handleChangeList('targetingCountryGroupList'),
            isActiveValue1: () => countryGroupCount > 0,
            getActiveTag1: (active: boolean) =>
              active
                ? countryGroupCount === 1
                  ? '1 Region'
                  : `${countryGroupCount} Regions`
                : 'All Regions',
            value2: this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW,
            handleChange2: () =>
              this.handleChange({
                target: {
                  name: 'TargetingCountryGroupIDsIsAllowed',
                  value:
                    this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW
                      ? EAllowStatus.DENY
                      : (EAllowStatus.ALLOW as any),
                },
              } as any),
            // if no country groups are selected, all country groups are selected by default
            isNoneSelectedAllSelected: true,
            showModalButton: true,
            modalButton: (
              <ModelSecondaryButton
                onClick={() => this.setState({ openRegionSelectTable: true })}
                disabled={!this.state.writeAuthorization.isAuthorized}
              >
                See Regions
              </ModelSecondaryButton>
            ),
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? countryGroupCount === 1
              ? '1 Region'
              : `${countryGroupCount} Regions`
            : 'All Regions',
      } as IInputRow;
      const TargetedCountriesRow = {
        renderType: 'MaterialDropdown',
        title1: 'Targeted Countries',
        field1: 'TargetingDeviceCountry',
        value1: this.state.targetingCountriesList,
        handleChange1: this.handleChangeList('targetingCountriesList'),
        handleAccept1: () => null,
        isActiveValue1: () => countriesCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? countriesCount === 1
              ? '1 Country'
              : `${countriesCount} Countries`
            : 'All Countries',
        value2: this.state.TargetingDeviceCountryIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceCountryIsAllowed',
              value:
                this.state.TargetingDeviceCountryIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        // if no countries are selected, all countries are selected (optional material search dropdown param)
        isNoneSelectedAllSelected: true,
      } as IInputRow;
      const LocalTargetingAllowedRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingAllowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingAllowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingAllowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return this.state.localTargetingAllowedParameters.length === 1
            ? '1 Local Target Included'
            : `${this.state.localTargetingAllowedParameters.length} Local Targets Included`;
        },
      } as IInputRow;
      const LocalTargetingDisallowedRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingDisallowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingDisallowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingDisallowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return this.state.localTargetingDisallowedParameters.length === 1
            ? '1 Local Target Excluded'
            : `${this.state.localTargetingDisallowedParameters.length} Local Targets Excluded`;
        },
      } as IInputRow;
      const GeoPanel = {
        title: 'Geo',
        panelInactiveRowTag: 'All Geos',
        panelActiveChipTitle: 'Custom',
        rows: [
          TargetedRegionsRow,
          TargetedCountriesRow,
          LocalTargetingAllowedRow,
          LocalTargetingDisallowedRow,
        ],
      } as IAccordionPanel;

      // Privacy Panel
      const CoppaRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: coppaOptions || [],
        title1: 'COPPA',
        field1: 'TargetedCoppa',
        value1: this.state.TargetedCoppa,
        defaultValue1: TargetingCoppaAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetedCoppa !== TargetingCoppaAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetedCoppa === TargetingCoppa0 ? 'COPPA = 0' : 'COPPA = 1') : '',
      } as IInputRow;
      const CCPARow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: ccpaOptions || [],
        title1: 'CCPA',
        field1: 'TargetingCCPA',
        value1: this.state.TargetingCCPA,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCCPA !== TargetingCCPAAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingCCPA !== TargetingCCPAAll
              ? 'CCPA Targeted'
              : 'CCPA All'
            : '',
      };

      const PrivacyPanel = {
        title: 'Privacy',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Privacy',
        rows: [CoppaRow, CCPARow],
      };

      // Venue Panel
      const venueRow = {
        renderType: 'TextfieldAndInclude',
        title1: 'Venue ID',
        field1: 'TargetedVenueID',
        value1: this.state.TargetedVenueID,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetedVenueID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedVenueID, 'Venue ID'),
        value2: this.state.TargetedVenueIDIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedVenueIDIsAllowed',
              value:
                this.state.TargetedVenueIDIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        placeholderText: 'Enter Venue IDs here, comma separated',
      } as IInputRow;

      const VenuePanel = {
        title: 'Venue',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Venue',
        rows: [venueRow],
      };

      const multiAccordionPanels = [
        AppPanel,
        ContentPanel,
        CustomPanel,
        GeoPanel,
        PrivacyPanel,
        VenuePanel,
      ] as IAccordionPanel[];

      return (
        <Grid
          item
          style={{
            marginBottom: 10,
            maxWidth: 900,
          }}
        >
          <Grid container direction='column'>
            {/* Header*/}
            <Grid item>
              <h2 style={{ marginBottom: 10 }}>Rule Targeting</h2>
            </Grid>
            <Grid item>
              <Typography style={{ fontSize: 14, marginBottom: 5 }}>
                Pick which object to apply to the rule and set targeting parameters to reach the
                desired granularity
              </Typography>
            </Grid>
            {/* Targeting Type Selection*/}
            <Grid item style={{ maxWidth: 500 }}>
              <PillSwitcher
                currentText={brandSafetyTargetingTypeToString(RuleTargetingType)}
                pills={BRAND_SAFETY_TARGETING_PILLS}
                customStyle={{ width: '250px', height: '40px', padding: '10px' }}
                onChange={(value: string) => {
                  const RuleTargetingType = brandSafetyTargetingTypeToNumber(value);
                  this.setState({
                    RuleTargetingType,
                  });
                }}
              />
            </Grid>
            {/* Targeting Dropdown*/}
            <Grid item style={{ marginTop: 15, marginBottom: 15 }}>
              {RuleTargetingType === BrandSafetyRuleTargetingTypeBidder && (
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='16px'
                  menuTitle={brandSafetyTargetingTypeToString(RuleTargetingType)}
                  list={this.state.bidderList}
                  enableMultiSelect={true}
                  onChange={(list) => {
                    this.handleChangeList('bidderList')(list);
                  }}
                  maxHeight={325}
                  showPrefixID
                />
              )}
              {RuleTargetingType === BrandSafetyRuleTargetingTypeBidderGroup && (
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='16px'
                  menuTitle={brandSafetyTargetingTypeToString(RuleTargetingType)}
                  list={this.state.bidderGroupList}
                  enableMultiSelect={true}
                  onChange={(list) => {
                    this.handleChangeList('bidderGroupList')(list);
                  }}
                  maxHeight={325}
                  showPrefixID
                />
              )}
              {RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup && (
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='16px'
                  menuTitle={brandSafetyTargetingTypeToString(RuleTargetingType)}
                  list={this.state.channelGroupList}
                  enableMultiSelect={true}
                  onChange={(list) => {
                    this.handleChangeList('channelGroupList')(list);
                  }}
                  maxHeight={325}
                  showPrefixID
                />
              )}
              {RuleTargetingType === BrandSafetyRuleTargetingTypeChannel && (
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='16px'
                  menuTitle={brandSafetyTargetingTypeToString(RuleTargetingType)}
                  list={this.state.channelList}
                  enableMultiSelect={true}
                  onChange={(list) => {
                    this.handleChangeList('channelList')(list);
                  }}
                  maxHeight={325}
                  showPrefixID
                />
              )}
            </Grid>
            {/* Accordion*/}
            <Grid item>
              <MultiAccordion
                title='Targeting Parameters'
                panels={multiAccordionPanels}
                disableEdit={!hasWriteCurrentRuleRight.isAuthorized}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // ########## FUNCTIONS for Geo Panel ####################

    // determines if the current user can write and returns permissions
    getWriteCampaignAuthorization = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_campaign'], this.props.user.user);
    };

    // [LocalTargeting] addLocalTargetingParam handles adding a new local targeting param
    addLocalTargetingParam = (allowed: boolean) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $push: [
              {
                type: 'country',
                country: '',
                states: '',
                cities: '',
                zips: '',
                dmas: '',
                isInputInCommaSeparatedMode: false,
              } as ILocalTargetingParameter,
            ],
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $push: [
                {
                  type: 'country',
                  country: '',
                  states: '',
                  cities: '',
                  zips: '',
                  dmas: '',
                  isInputInCommaSeparatedMode: false,
                } as ILocalTargetingParameter,
              ],
            },
          ),
        });
      }
    };

    // [LocalTargeting] updateLocalTargetingParam handles type or value change for local targeting params
    updateLocalTargetingParam = (allowed: boolean, index: number, updates: object) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            [index]: {
              $set: { ...this.state.localTargetingAllowedParameters[index], ...updates },
            },
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              [index]: {
                $set: { ...this.state.localTargetingDisallowedParameters[index], ...updates },
              },
            },
          ),
        });
      }
    };

    // [LocalTargeting] deleteLocalTargetingParam handles deleting a local targeting param
    deleteLocalTargetingParam = (allowed: boolean, index: number) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $splice: [[index, 1]],
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $splice: [[index, 1]],
            },
          ),
        });
      }
    };

    deleteCountryGroupFunc = (countryGroupID: string, reloadBidder: boolean) => {
      const { publisherCountryGroups, targetingCountryGroupList } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      if (foundCountryGroup) {
        const clonedPublisherCountryGroups = cloneDeep(publisherCountryGroups);
        const filteredPublisherCountryGroups = clonedPublisherCountryGroups.filter(
          (countryGroup: ICountryGroup) => countryGroup.ID !== foundCountryGroup.ID,
        );

        const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
        delete clonedTargetingCountryGroupList[foundCountryGroup.ID];

        deleteCountryGroup(foundCountryGroup).then(() => {
          this.setState(
            {
              openRegionCreateEditDialog: false,
              openRegionSelectTable: false,
              publisherCountryGroups: filteredPublisherCountryGroups,
              targetingCountryGroupList: clonedTargetingCountryGroupList,
              updatingCountryGroup: false,
              snackbarMessage: 'Sucessfully deleted country group',
              snackbarError: false,
            },
            reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
          );
        });
      }
    };

    // [LocalTargeting] exportLocalTargetingParamToJSON exports all the local targeting params to a json string
    exportLocalTargetingParamToJSON = (allowed: boolean): string => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      const filteredList = exportLocalTargetingToJSON(params);
      return JSON.stringify(filteredList);
    };

    handleSetUpdatingCountryGroup = (updatingCountryGroup: boolean) => {
      this.setState({ updatingCountryGroup });
    };

    handleOpenRegionSelectDialog = (countryGroupID: string) => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      let newCreateEditRegionList = generateCountriesMenuList();
      let newCreateEditRegionName = '';
      if (foundCountryGroup) {
        newCreateEditRegionList = generateCountryMenuListFromIsos(
          foundCountryGroup.CountryIsos.split(','),
        );
        newCreateEditRegionName = foundCountryGroup.Name;
      }
      this.setState({
        createEditRegionID: countryGroupID,
        createEditRegionList: newCreateEditRegionList,
        createEditRegionName: newCreateEditRegionName,
        openRegionCreateEditDialog: true,
        openRegionSelectTable: false,
      });
    };

    getCountryGroupsByPublisherID = () => {
      const { targetingCountryGroupList } = this.state;
      const { session } = this.props;

      getCountryGroupsByPublisherID(session.publisher.ID)
        .then((countryGroups: ICountryGroup[]) => {
          // create the updated menu list and update the state
          const updatedCountryGroupMenuList = generateNewTargetingCountryGroupList(
            targetingCountryGroupList,
            countryGroups,
          );
          this.setState({
            publisherCountryGroups: countryGroups,
            targetingCountryGroupList: updatedCountryGroupMenuList,
          });
        })
        .then(this.populateTargetingCountryGroupList);
    };

    getCommonRegionGroupsByIDs = () => {
      getCountryGroupsByIDs(commonRegionGroupsIDs, this.props.session.publisher.ID)
        .then((regionGroups) => {
          this.setState({ commonRegionGroups: regionGroups[0] });
        })
        .catch(() => {
          this.setState({
            commonRegionGroups: [],
            snackbarError: true,
            snackbarMessage: 'Error loading common country groups',
          });
        });
    };

    getCreativeValidationsAllowed = () => {
      this.setState(
        {
          loadingCreativeValidations: true,
        },
        () => {
          const query = {
            adomain_filter: this.state.TargetedAdomains,
            category_filter: this.state.TargetedIABs,
            creative_url_filter: this.state.TargetedMediafiles,
            creative_id_filter: this.state.TargetedCreativeIDs,
            page: 0,
            order_by: 0,
            site_filter: '',
            bidder_filter: '',
            bidder_tier_filter: '',
            demand_source_filter: '',
          };

          getCreativeValidationsV2(this.props.session.publisher.ID, REVIEW_STATUS_ALLOWED, query)
            .then((allowedCreativeValidations: ICreativeValidation[]) => {
              this.setState({
                allowedCreativeValidations,
                loadingCreativeValidations: false,
              });
            })
            .catch(() => {
              this.setState({
                allowedCreativeValidations: [],
                snackbarError: true,
                snackbarMessage: 'Error loading allowed creative validations',
                loadingCreativeValidations: false,
              });
            });
        },
      );
    };

    // populateTargetingCountryGroupList sets the selected value in targetingCountryGroupList
    // based on the TargetingCountryGroupIDs on the headerbidder, then updates the state
    populateTargetingCountryGroupList = (): void => {
      const { targetingCountryGroupList, TargetingCountryGroupIDs } = this.state;

      const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
      const selectedCountryGroupIDs = TargetingCountryGroupIDs.split(',');

      for (const selectedCountryGroupID of selectedCountryGroupIDs) {
        if (clonedTargetingCountryGroupList[selectedCountryGroupID] !== undefined) {
          clonedTargetingCountryGroupList[selectedCountryGroupID].selected = true;
        }
      }

      this.setState({
        targetingCountryGroupList: clonedTargetingCountryGroupList,
      });
    };

    populateTargetingCountriesList() {
      // Device local targeting countries setup
      // If number of selected countries < total/2, we are in Allow list mode
      const ckeys: string[] = this.state.TargetingDeviceCountry.split(',');
      if (ckeys.length < getAllCountries().length / 2) {
        // Allowlist mode
        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = true;
          }
        }
        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        });
      } else {
        // Denylist mode
        for (const key of Object.keys(this.state.targetingCountriesList)) {
          this.state.targetingCountriesList[key].selected = true;
        }

        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = false;
          }
        }

        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Denylist,
        });
      }
    }

    renderAllRegionsDialog = (regionRow: IInputRow) => {
      const { openRegionSelectTable, writeAuthorization } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };
      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={regionRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openRegionSelectTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openRegionSelectTable}
              onClose={() => this.setState({ openRegionSelectTable: false })}
            >
              {this.renderRegionListTableDialog()}
              <DialogActions>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, false)}>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            this.renderCreateEditRegionDialog()
          )}
        </Grid>
      );
    };

    // Local Targeting Disallowed
    renderLocalTargetingAllowedPanel = () => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingAllowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingAllowedLogic}
          localTargetingLogicFieldName='LocalTargetingAllowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed}
          addLocalTargetingParam={() => this.addLocalTargetingParam(true)}
          resourceName='Brand Safety Rule'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(true, index, updates)
          }
          deleteLocalTargetingParam={(index: number) => this.deleteLocalTargetingParam(true, index)}
          titleOverride={includedTitleOverride}
        />
      );
    };

    // Local Targeting Allowed
    renderLocalTargetingDisallowedPanel = () => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingDisallowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingDisallowedLogic}
          localTargetingLogicFieldName='LocalTargetingDisallowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed}
          addLocalTargetingParam={() => this.addLocalTargetingParam(false)}
          resourceName='Brand Safety Rule'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(false, index, updates)
          }
          deleteLocalTargetingParam={(index: number) =>
            this.deleteLocalTargetingParam(false, index)
          }
          titleOverride={excludedTitleOverride}
        />
      );
    };

    // [LocalTargeting] renderLocalTargeting renders the local targeting params
    renderLocalTargeting = (allowed: boolean, disabled: boolean) => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      return (
        <Grid container direction='column' justify='center' alignItems='flex-start' spacing={2}>
          {params.map((localParam: ILocalTargetingParameter, index: number) => (
            <div style={{ marginLeft: '8px' }}>
              {/* Type */}
              <Grid item style={{ fontSize: '16px' }}>
                Type:&nbsp;&nbsp;
                <Select
                  value={localParam.type}
                  style={{ width: '120px' }}
                  disabled={disabled}
                  onChange={(event: any) => {
                    // If type change, delete previous value
                    if (localParam.type !== event.target.value) {
                      localParam.value = '';
                      localParam.currentValue = '';
                    }
                    this.updateLocalTargetingParam(allowed, index, { type: event.target.value });
                  }}
                >
                  <MenuItem value='state'>State</MenuItem>
                  <MenuItem value='city'>City</MenuItem>
                  <MenuItem value='zip'>Zip Code</MenuItem>
                  <MenuItem value='dma'>DMA Code</MenuItem>
                </Select>
              </Grid>

              {/* Value & Delete */}
              <Grid item style={{ marginTop: '6px', marginBottom: '25px' }}>
                {localParam.type === 'state' &&
                  this.renderLocalParamStateInput(allowed, index, disabled)}
                {localParam.type === 'city' &&
                  this.renderLocalParamCityInput(allowed, index, disabled)}
                {localParam.type === 'zip' &&
                  this.renderLocalParamZipInput(allowed, index, disabled)}
                {localParam.type === 'dma' &&
                  this.renderLocalParamDMAInput(allowed, index, disabled)}
              </Grid>
            </div>
          ))}

          {/* 'Add New' button */}
          <Grid item style={{ padding: '0px 8px 24px 8px' }}>
            <Button
              disabled={disabled}
              variant='contained'
              color='secondary'
              style={{ backgroundColor: getColorTheme('primaryButton') }}
              onClick={() => this.addLocalTargetingParam(allowed)}
            >
              Add Local Targeting
            </Button>
          </Grid>
        </Grid>
      );
    };

    renderRegionListTableDialog = () => {
      const { user } = this.props;
      const { publisherCountryGroups, updatingCountryGroup } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: 'Region Name',
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'CountriesTargeted',
          title: 'Countries Targeted',
          renderType: 'normal',
          searchable: false,
          maxWidth: '100px',
        },
        { field: 'Actions', title: 'Actions', renderType: 'delete', searchable: false },
      ];

      const listTableData: ICountryGroupRowData[] = publisherCountryGroups.map(
        (countryGroup: ICountryGroup) => {
          const countryGroupName = checkUserInfoMasked(user.user)
            ? `demo_site_${countryGroup.ID}`
            : countryGroup.Name;
          return {
            ID: countryGroup.ID.toString(),
            Name: countryGroupName,
            CountriesTargeted:
              (countryGroup.CountryIsos && countryGroup.CountryIsos.split(',').length) || 0,
          };
        },
      );

      return (
        <Grid item style={{ margin: '20px 15px 5px 15px', width: '97%' }}>
          <ListTable
            title={''}
            columns={listTableColumns}
            data={listTableData}
            isUpdating={updatingCountryGroup}
            handleSetUpdating={this.handleSetUpdatingCountryGroup}
            handleDeleteItem={(countryGroupID: string) =>
              this.deleteCountryGroupFunc(countryGroupID, true)
            }
            handleOpenModal3={this.handleOpenRegionSelectDialog}
            fixedEnabled={true}
            renderCustomToolbar={this.renderCustomToolbar}
            pageSize={10}
          />
        </Grid>
      );
    };

    // renderCustomToolbar renders the toolbar at the top of the list table
    renderCustomToolbar = (props: any): ReactElement => {
      const { classes } = this.props;
      const { updatingCountryGroup } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Grid item className={classes.toolbarRow}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item>
              <MTableToolbar {...copyProps} />
            </Grid>
            <RowButton
              right={
                <ButtonView
                  onClick={() => {
                    this.setState({
                      openRegionSelectTable: false,
                      openRegionCreateEditDialog: true,
                    });
                  }}
                  text='+ New Region'
                  active={updatingCountryGroup}
                />
              }
            />
          </Grid>
        </Grid>
      );
    };

    renderCreateEditRegionDialog = () => {
      const { classes, session } = this.props;
      const {
        createEditRegionID,
        createEditRegionList,
        createEditRegionName,
        errors,
        openRegionCreateEditDialog,
        writeAuthorization,
        commonRegionGroups,
      } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      const newCountryIsos = Object.keys(createEditRegionList).filter(
        (key) => createEditRegionList[key].selected,
      );
      const newCountryGroup = {
        CountryIsos: newCountryIsos.map((countryIso) => countryIso.toUpperCase()).join(','),
        Name: createEditRegionName,
        PublisherID: parseInt(session.publisher.ID, 10),
      } as ICountryGroup;

      // clicking on pre-selectable common region selects all default countries in that region
      const onCommonRegionClick = (countryGroup: ICountryGroup) => {
        this.setState({
          createEditRegionList: generateCountryMenuListFromIsos(
            countryGroup.CountryIsos.split(','),
          ),
          createEditRegionName: countryGroup.Name,
        });
      };

      return openRegionCreateEditDialog ? (
        <Grid item style={{ width: '100%' }}>
          <Dialog
            fullWidth
            maxWidth='sm'
            keepMounted
            open={openRegionCreateEditDialog}
            onClose={() => onCloseFn(false, false)}
          >
            <Grid item style={{ width: '100%' }}>
              <Typography
                className={classes.parameterHeaders}
                style={{ marginLeft: 30, marginTop: 30, fontSize: 20 }}
              >
                {!createEditRegionID ? 'Create New Region' : 'Edit Region'}
              </Typography>
              <Grid item style={{ marginLeft: 50 }}>
                <TextField
                  label='Region Name'
                  name='createEditRegionName'
                  value={createEditRegionName}
                  onChange={this.handleChange}
                  error={!!errors.createEditRegionName}
                  helperText={errors.createEditRegionName}
                />
                <Grid>
                  {(commonRegionGroups || []).map((countryGroup: ICountryGroup) => {
                    return (
                      <Button
                        key={countryGroup.ID}
                        style={{ marginTop: 10 }}
                        onClick={() => onCommonRegionClick(countryGroup)}
                      >
                        {countryGroup.Name}
                      </Button>
                    );
                  })}
                </Grid>
              </Grid>

              <Divider style={{ margin: 10, height: 1, color: 'black' }} />

              <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
                Select countries to include in region
              </Typography>
              <Grid item style={{ marginLeft: 50, height: 500 }}>
                <MaterialSearchDropdownMulti
                  forceOpen={true}
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  fontSize='14px'
                  selectAll={true}
                  menuTitle={''}
                  list={createEditRegionList}
                  disabled={!writeAuthorization.isAuthorized}
                  onChange={this.handleChangeList('createEditRegionList')}
                  handleMenuAcceptClick={() => null}
                  isNoneSelectedAllSelected={true}
                  keepDropdownOpen={true}
                />
              </Grid>
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => {
                    const regionValidationErrors = validatorFactory(regionValidationSetting)(
                      this.state,
                    );
                    if (hasErrors(regionValidationErrors)) {
                      const errorText = Object.values(errors)
                        .filter((value) => value.length)
                        .join('. ');
                      this.setState(
                        {
                          errors: regionValidationErrors,
                          snackbarMessage: `Please fix errors before saving region: ${errorText}`,
                          snackbarError: true,
                        },
                        () => {
                          setTimeout(() => {
                            this.setState({
                              errors: {} as IErrors,
                            });
                            this.snackbarClose();
                          }, 6000);
                        },
                      );
                      return;
                    }

                    if (!createEditRegionID) {
                      createCountryGroup(newCountryGroup).then(() => {
                        this.setState({
                          snackbarError: false,
                          snackbarMessage: 'Successfully created region',
                        });
                        onCloseFn(true, false);
                      });
                    } else {
                      newCountryGroup.ID = parseInt(createEditRegionID, 10);
                      this.setState(
                        {
                          updatingCountryGroup: true,
                        },
                        () => {
                          updateCountryGroup(newCountryGroup).then(() => {
                            this.setState({
                              snackbarError: false,
                              snackbarMessage: 'Successfully updated region',
                              updatingCountryGroup: false,
                            });
                            onCloseFn(true, false);
                          });
                        },
                      );
                    }
                  }}
                >
                  Save
                </Button>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, true)}>
                  Cancel
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      ) : null;
    };

    // [LocalTargeting]{RENDERING} renderLocalParamStateInput renders the state input for local targeting params
    renderLocalParamStateInput = (allowed: boolean, index: number, disabled: boolean) => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      return (
        <Grid container direction='column' justify='center' alignItems='flex-start'>
          {/* Comma-separated option checkbox */}
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disabled}
                  checked={params[index].isInputInCommaSeparatedMode}
                  onChange={() => {
                    this.updateLocalTargetingParam(allowed, index, {
                      isInputInCommaSeparatedMode: !params[index].isInputInCommaSeparatedMode,
                    });
                  }}
                  color='primary'
                />
              }
              label='Enable comma-separated input mode.'
            />
          </Grid>
          {/* Input field + Delete button */}
          <Grid item>
            <Grid container direction='row' justify='flex-start' alignItems='center'>
              {/* Input Field */}
              <Grid item>
                {params[index].isInputInCommaSeparatedMode ? (
                  <TextField
                    disabled={disabled}
                    value={params[index].value}
                    multiline
                    variant='outlined'
                    rows={3}
                    placeholder='Values can be comma-separated, use two letter abbreviations for states (Ex: CA, UT)'
                    onChange={(event: any) =>
                      this.updateLocalTargetingParam(allowed, index, { value: event.target.value })
                    }
                    style={{ width: '400px' }}
                  />
                ) : (
                  <Autocomplete
                    disabled={disabled}
                    multiple
                    disableCloseOnSelect
                    options={allSupportedStates}
                    getOptionLabel={(o: ICountryState) => o.name}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {option.name}
                      </React.Fragment>
                    )}
                    style={{ width: '400px' }}
                    renderInput={(params) => (
                      <TextField {...params} variant='outlined' label='States' />
                    )}
                    onChange={(_event: object, values: ICountryState[]) =>
                      this.updateLocalTargetingParam(allowed, index, {
                        value: values.map((v: ICountryState) => v.name).join(','),
                        currentValue: '',
                      })
                    }
                    defaultValue={stateNamesToStateList(
                      params[index].value
                        .split(',')
                        .filter((s: string) => s.length > 0)
                        .map((o: string) => o.trim()),
                    )}
                  />
                )}
              </Grid>
              {/* Delete Button */}
              <Grid item>{this.renderLocalParamDeleteButton(allowed, index, disabled)}</Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // [LocalTargeting]{RENDERING} renderLocalParamCityInput renders the state input for local targeting params
    renderLocalParamCityInput = (allowed: boolean, index: number, disabled: boolean) => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      return (
        <Grid container direction='column' justify='center' alignItems='flex-start'>
          {/* Comma-separated option checkbox */}
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disabled}
                  checked={params[index].isInputInCommaSeparatedMode}
                  onChange={() => {
                    this.updateLocalTargetingParam(allowed, index, {
                      isInputInCommaSeparatedMode: !params[index].isInputInCommaSeparatedMode,
                    });
                  }}
                  color='primary'
                />
              }
              label='Enable comma-separated input mode.'
            />
          </Grid>
          {/* Input field + Delete button */}
          <Grid item>
            <Grid container direction='row' justify='flex-start' alignItems='center'>
              {/* Input Field */}
              <Grid item>
                {params[index].isInputInCommaSeparatedMode ? (
                  <TextField
                    disabled={disabled}
                    value={params[index].value}
                    multiline
                    variant='outlined'
                    rows={3}
                    placeholder='Values can be comma-separated (Ex: San Francisco, Los Angeles)'
                    onChange={(event: any) =>
                      this.updateLocalTargetingParam(allowed, index, { value: event.target.value })
                    }
                    style={{ width: '400px' }}
                  />
                ) : (
                  <Autocomplete
                    multiple
                    disabled={disabled}
                    // freeSolo
                    disableCloseOnSelect
                    defaultValue={params[index].value
                      .split(',')
                      .filter((s: string) => s.length > 0)
                      .map((o: string) => o.trim())}
                    options={params[index].currentValue.length <= 2 ? [] : USCities}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {option}
                      </React.Fragment>
                    )}
                    style={{ width: '400px' }}
                    renderInput={(params) => (
                      <TextField {...params} variant='outlined' label='Cities' />
                    )}
                    onInputChange={(_event: object, value: string) =>
                      this.updateLocalTargetingParam(allowed, index, { currentValue: value })
                    }
                    onChange={(_event: object, values: string[]) =>
                      this.updateLocalTargetingParam(allowed, index, {
                        value: values.join(','),
                        currentValue: '',
                      })
                    }
                  />
                )}
              </Grid>
              {/* Delete Button */}
              <Grid item>{this.renderLocalParamDeleteButton(allowed, index, disabled)}</Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };
    // [LocalTargeting]{RENDERING} renderLocalParamZipInput renders the state input for local targeting params
    renderLocalParamZipInput = (allowed: boolean, index: number, disabled: boolean) => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      return (
        <Grid container direction='row' justify='flex-start' alignItems='center'>
          {/* Input Field */}
          <Grid item>
            <TextField
              disabled={disabled}
              value={params[index].value}
              multiline
              variant='outlined'
              rows={3}
              placeholder='Values can be comma-separated (Ex: 90800, 90801)'
              onChange={(event: any) =>
                this.updateLocalTargetingParam(allowed, index, { value: event.target.value })
              }
              style={{ width: '400px' }}
            />
          </Grid>
          {/* Delete Button */}
          <Grid item>{this.renderLocalParamDeleteButton(allowed, index, disabled)}</Grid>
        </Grid>
      );
    };
    // [LocalTargeting]{RENDERING} renderLocalParamDMAInput renders the state input for local targeting params
    renderLocalParamDMAInput = (allowed: boolean, index: number, disabled: boolean) => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      return (
        <Grid container direction='row' justify='flex-start' alignItems='center'>
          {/* Input Field */}
          <Grid item>
            <TextField
              disabled={disabled}
              value={params[index].value}
              multiline
              variant='outlined'
              rows={3}
              placeholder='Values can be comma-separated (Ex: 508, 509)'
              onChange={(event: any) =>
                this.updateLocalTargetingParam(allowed, index, { value: event.target.value })
              }
              style={{ width: '400px' }}
            />
          </Grid>
          {/* Delete Button */}
          <Grid item>{this.renderLocalParamDeleteButton(allowed, index, disabled)}</Grid>
        </Grid>
      );
    };

    // [LocalTargeting]{RENDERING} renderLocalParamDeleteButton renders the delete button for local params input fields
    renderLocalParamDeleteButton = (allowed: boolean, index: number, disabled: boolean) => (
      <IconButton
        disabled={disabled}
        aria-label='delete'
        style={disabled ? { color: '#a7a8a7' } : { color: getColorTheme('secondaryButtonText') }}
        onClick={() => {
          this.deleteLocalTargetingParam(allowed, index);
        }}
      >
        <DeleteIcon />
      </IconButton>
    );

    // ############################## RENDER RULE TARGETING TYPE CHIP ##############################
    // chip displayed for the rule targeting type switch menu (Global, Channel, Bidders ...)
    renderRuleTargetingTypeChip(targetedType: number, title: string, disabled?: boolean) {
      // get selected/unselected chip
      const Chip =
        this.state.RuleTargetingType === targetedType
          ? ChipTargetingTypeSelected
          : ChipTargetingTypeUnselected;
      // render corresponding
      return (
        <a
          onClick={() => {
            if (disabled) {
              return; // chip is disabled, don't do anything
            }
            this.targetingTypeChangeHandler(targetedType);
          }}
        >
          <Chip label={title} style={disabled ? { color: '#c0c0c0' } : {}} />
        </a>
      );
    }

    // ############################## RENDER RULE TARGETING TYPE SELECTOR ##############################
    renderRuleTypeSelector(disabled?: boolean) {
      const { ruleType, RuleTargetingType } = this.state;
      return (
        <Grid item style={{ maxWidth: 700 }}>
          <PillSwitcher
            disabled={disabled}
            currentText={brandSafetyRuleTypeToString(ruleType)}
            pills={getBrandSafetyTypePills(
              RuleTargetingType === BrandSafetyRuleTargetingTypeChannel ||
                RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup,
            )}
            customStyle={{ width: '250px', height: '40px', padding: '10px' }}
            onChange={(value: string) => {
              this.setState({
                ruleType: brandSafetyRuleTypeToNumber(value),
              });
            }}
          />
        </Grid>
      );
    }

    // ############################## RENDER RULE TYPE SECTION ##############################
    renderRuleType() {
      // permissions
      const disabled = !this.state.hasWriteCurrentRuleRight.isAuthorized;
      // rendering
      return (
        <div>
          {/* RULE TYPE TYPE SELECTOR*/}
          {this.renderRuleTypeSelector(disabled)}
          {/* RULE TYPE CONFIG*/}
          {this.state.ruleType === RuleTypeIAB &&
            this.renderRuleTypeIABEntry(RuleTargetingTab, disabled, undefined)}
          {this.state.ruleType === RuleTypeAdomain &&
            this.renderRuleTypeAdomainEntry(RuleTargetingTab, false, disabled, undefined)}
          {this.state.ruleType === RuleTypeMediafile &&
            this.renderRuleTypeMediafileEntry(RuleTargetingTab, disabled)}
          {this.state.ruleType === RuleTypeLanguage &&
            this.renderRuleTypeLanguageEntry(RuleTargetingTab, disabled)}
          {this.state.ruleType === RuleTypeCreativeID &&
            this.renderRuleTypeCreativeIDEntry(RuleTargetingTab, disabled)}
          {this.state.ruleType === RuleTypeEventTracker &&
            this.renderRuleTypeEventTrackerEntry(RuleTargetingTab, disabled)}
        </div>
      );
    }

    // ############################## RENDER TOP BAR WITH RULE NAME AND ACTIVE SWITCH ##############################
    renderTopBar(classes: { [key: string]: string }) {
      // permissions
      const canEditRule = this.state.hasWriteCurrentRuleRight.isAuthorized;
      // rendering
      return (
        <div>
          <ElevationScroll {...this.props}>
            <AppBar
              position='relative'
              elevation={0}
              style={{
                backgroundColor: '#F8faff',
                border: '#cbcbcb',
                borderTopStyle: 'solid',
                borderBottomStyle: 'solid',
                borderTopWidth: 'thin',
                borderBottomWidth: 'thin',
                position: 'fixed',
              }}
            >
              <Toolbar>
                <Grid container direction='row' justify='flex-start' alignItems='center'>
                  {/* RULE NAME*/}
                  <Grid item xs={3}>
                    <ModernTextField
                      disabled={!canEditRule}
                      value={
                        checkUserInfoMasked(this.props.user.user)
                          ? 'demo_rule_' + this.state.ID
                          : this.state.Name
                      }
                      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({
                          Name: target.value,
                        });
                      }}
                    />
                  </Grid>

                  {/* ACTIVE SWITCH*/}
                  <Grid item xs={2} style={{ paddingLeft: '20px' }}>
                    <span
                      style={{
                        color: 'black',
                        fontSize: 'medium',
                      }}
                    >
                      Active
                    </span>
                    <Switch
                      disabled={!canEditRule}
                      checked={this.state.Active === BrandSafetyRuleActiveActive}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.handleRuleActiveSwitchChange(event.target.checked);
                      }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    {/* SAVE BUTTON*/}
                    <ModelPrimaryButton
                      variant='contained'
                      onClick={() => this.saveRule()}
                      disabled={!canEditRule}
                    >
                      Save
                    </ModelPrimaryButton>
                    {/* CLOSE BUTTON*/}
                    <Button
                      style={{ color: '#707070' }}
                      className={classes.button}
                      onClick={this.handleCloseButtonClick}
                    >
                      Close
                    </Button>
                    {/* DELETE BUTTON*/}
                    {!this.isNewRule() && ( // don't display delete button for new rule
                      <Tooltip title='Delete'>
                        <Button
                          disabled={!canEditRule}
                          style={canEditRule ? { color: deleteColor } : { color: '#d2d2d2' }}
                          className={classes.button}
                          onClick={this.handleDeleteButtonClick}
                        >
                          <DeleteIcon />
                        </Button>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
          </ElevationScroll>
          <Toolbar />
        </div>
      );
    }

    // ############################## RENDER RULE TARGETING TAB ##############################
    renderRuleTargetingTab = (): ReactElement => {
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      const canEditRule = this.state.hasWriteCurrentRuleRight.isAuthorized;
      return (
        <Grid
          style={{
            maxWidth: '100%',
            marginBottom: '15px',
          }}
        >
          {/* RULE TARGETING*/}
          {this.renderBrandSafetyRuleTargeting()}

          {/* divider */}
          <Divider
            style={{
              marginBottom: '24px',
              marginTop: '34px',
              width: '100%',
            }}
          />

          {/* RULE TYPE*/}
          <h2>Rule type {!this.state.hasWriteCurrentRuleRight.isAuthorized && <>(read only)</>}</h2>
          <Typography style={{ fontSize: 14, marginBottom: 5 }}>
            Define the type of rule and elements to exclude or include
          </Typography>
          {this.renderRuleType()}
          {this.renderRuleTargetedExceptionDialog()}

          {isSuperUser && (
            <InputGridRow style={{ marginTop: 30 }} text='Options'>
              <Grid />
            </InputGridRow>
          )}
          <InputGridRow
            text='Review Blocked Creatives'
            subRowNumber={1}
            infoIconText={`Use this option to enable the creatives being blocked to populate the Creative Review Tab within Brand Safety. It will allow you to view the ad, the creative URL and the associated IAB Category & Adomain in order to decide if you'd like to confirm the block or allow the ad to run by creating an exception.`}
          >
            <Switch
              name='EnableSaveCreativeValidations'
              disabled={!canEditRule}
              checked={this.state.EnableSaveCreativeValidations === EBool.EBool_TRUE}
              onChange={this.handleChange}
            />
          </InputGridRow>
          <InputGridRow
            text='Block Bids with missing values'
            subRowNumber={1}
            infoIconText='Use this option to enable blocking bid responses if IAB Category or ADomain is null or missing. The block list has to be targeting IAB Categories to block bid responses with empty IAB Categories. The block list has to be targeting ADomains to block bid responses with empty ADomains'
          >
            <Switch
              name='EnableBlockBidsWithEmptyIABCatAdomain'
              disabled={!canEditRule}
              checked={this.state.EnableBlockBidsWithEmptyIABCatAdomain === EBool.EBool_TRUE}
              onChange={this.handleChange}
            />
          </InputGridRow>

          {/* force small margin at the bottom of the paper*/}
          <Grid style={{ height: '15px' }}>&nbsp;</Grid>
        </Grid>
      );
    };

    createException = () => {
      this.setState(
        {
          BrandSafetyRuleExceptions: update(this.state.BrandSafetyRuleExceptions, {
            $push: [
              {
                ID: 0,
                Name: 'RuleException-' + new Date().getTime(),
                BidderIDs: '',
                AllowedAdomains: '',
                AllowedIABCategories: '',
                TargetedIABExceptions: '',
              },
            ],
          }),
        },
        () => {
          this.handleOpenEditRuleExceptionDialog(
            undefined,
            this.state.BrandSafetyRuleExceptions.length - 1,
          );
        },
      );
    };

    deleteException = (_: any, idx: number) => {
      this.setState({
        BrandSafetyRuleExceptions: update(this.state.BrandSafetyRuleExceptions, {
          $splice: [[idx, 1]],
        }),
      });

      // the delete modal expects a promise to be returned
      return new Promise((resolve) => resolve(undefined));
    };

    handleOpenBidderSelectDialog = (_: any, idx: number) => {
      this.setState({
        openBidderSelectTable: true,
        selectedRowIdx: idx,
      });
    };

    getTargetChannelIDs = (): string[] => {
      const targetChannels: { [key: number]: boolean } = {};
      const { channelGroups, RuleTargetingType } = this.state;
      const targetedObjects = this.CreateTargetedObjectsTable();
      if (RuleTargetingType === BrandSafetyRuleTargetingTypeChannel) {
        targetedObjects.forEach((t: IBrandSafetyRuleAssociationTable) => {
          targetChannels[t.TargetID] = true;
        });
      } else if (RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup) {
        for (let i = 0; i < targetedObjects.length; i++) {
          for (let j = 0; j < channelGroups.length; j++) {
            if (targetedObjects[i].TargetID === channelGroups[j].ID) {
              for (const channelIDSt of channelGroups[j].ChannelIDs.split(',')) {
                const channelID = parseInt(channelIDSt, 10);
                if (!isNaN(channelID)) {
                  targetChannels[channelID] = true;
                }
              }
            }
          }
        }
      }

      return Object.keys(targetChannels);
    };

    handleOpenRuleTargetedExceptionDialog = (targetedExceptionIABCode: string) => {
      this.setState({
        openRuleTargetedExceptionDialog: true,
        openRuleTargetedExceptionDialogIABCode: targetedExceptionIABCode,
      });
    };

    handleOpenEditRuleExceptionDialog = (_: any, idx: number) => {
      const { BrandSafetyRuleExceptions, headerBidders } = this.state;
      const bidderListAllowed = {} as IMenuList;
      const exception = BrandSafetyRuleExceptions[idx];
      headerBidders
        .filter((hb: IHeaderBidder): boolean => {
          const targetChannels = this.getTargetChannelIDs();
          return targetChannels.reduce(
            (ret: boolean, channelIDStr: string) =>
              ret || hb.SiteIDS.includes(parseInt(channelIDStr, 10)),
            false,
          );
        })
        .forEach((hb: IHeaderBidder) => {
          const bidderIDs =
            exception.BidderIDs === '' ? ([] as string[]) : exception.BidderIDs.split(',');
          const bidderName = checkUserInfoMasked(this.props.user.user)
            ? 'Bidder_' + hb.ID
            : hb.Name;
          bidderListAllowed[hb.ID] = {
            title: bidderName,
            selected: bidderIDs.includes(hb.ID),
            ID: hb.ID,
          };
        });

      this.setState({
        openEditRuleException: true,
        selectedRowIdx: idx,
        bidderListAllowed,
        userEntryIABPrefixAllowed: '',
        userEntryIABSuffixAllowed: '',
        userEntryIABListAllowed: '',
        adomainUserEntryAllowed: '',
        adomainAllowed:
          exception.AllowedAdomains === ''
            ? ([] as string[])
            : exception.AllowedAdomains.split(','),
        iabListAllowed:
          exception.AllowedIABCategories === ''
            ? ([] as IIncludeExcludeTableElement[])
            : exception.AllowedIABCategories.split(',').map(
                (iabCode: string) =>
                  ({
                    ID: iabCode.replace('!', ''),
                    title: iabCode.replace('!', ''),
                    included: true,
                  }) as IIncludeExcludeTableElement,
              ),
      });
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.name === 'EnableSaveCreativeValidations') {
        this.setState({
          EnableSaveCreativeValidations:
            this.state.EnableSaveCreativeValidations === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
        });
      } else if (target.name === 'EnableBlockBidsWithEmptyIABCatAdomain') {
        this.setState({
          EnableBlockBidsWithEmptyIABCatAdomain:
            this.state.EnableBlockBidsWithEmptyIABCatAdomain === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
        });
      } else {
        this.setState({
          [target.name]: target.value,
        });
      }
    };

    // ############################## RENDER RULE EXCEPTIONS LIST #############################
    renderRuleExceptionsList = (): ReactElement => {
      const filteredListTableColumns = listTableColumns.filter((col: IListTableColumn) => {
        return (
          (this.state.ruleType === RuleTypeIAB && col.field !== 'AllowedIABCategories') ||
          (this.state.ruleType === RuleTypeAdomain && col.field !== 'AllowedAdomains')
        );
      });

      const exceptionData = this.state.BrandSafetyRuleExceptions.map(
        (exception: IBrandSafetyRuleException): IBrandSafetyRuleExceptionRowData => {
          let allowedAdomainsText = exception.AllowedAdomains;
          if (
            this.state.TargetingAdomainExceptionState ===
            BrandSafetyRuleTargetingAdomainExceptionStateAllowAll
          ) {
            allowedAdomainsText = 'All Adomains';
          }
          return {
            ID: exception.ID,
            Name: exception.Name,
            BidderIDs: exception.BidderIDs === '' ? 0 : exception.BidderIDs.split(',').length,
            AllowedIABCategories: exception.AllowedIABCategories,
            AllowedAdomains: allowedAdomainsText,
          };
        },
      );

      return (
        <Grid container direction='column'>
          <Grid item style={{ marginLeft: 15, marginBottom: 15, width: '100%' }}>
            <ListTable
              title='Allow List'
              columns={filteredListTableColumns}
              data={exceptionData}
              handleOpenModal={this.handleOpenEditRuleExceptionDialog}
              handleOpenModal2={this.handleOpenBidderSelectDialog}
              handleSetUpdating={noopVoid}
              handleDeleteItem={this.deleteException}
            />
          </Grid>
        </Grid>
      );
    };

    // ############################## RENDER RULE EXCEPTIONS TAB ##############################
    renderRuleExceptionsTab = (): ReactElement => {
      // permissions
      const canWrite = this.state.hasWriteCurrentRuleRight.isAuthorized;
      // rendering
      return (
        <div style={{ maxWidth: '1200px', marginBottom: '15px' }}>
          <Grid
            container
            direction='row'
            justify='space-between'
            alignItems='center'
            style={{ marginBottom: '30px' }}
          >
            <Grid item lg={6} md={6} sm={6} xs={12} />
            <Grid container justify={'flex-end'} alignItems='center'>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <Grid container justify='flex-end' alignItems='center' spacing={2}>
                  <Grid item>
                    {!canWrite ? (
                      <ModelMediumButton
                        variant='contained'
                        onClick={this.createException}
                        disabled={true}
                      >
                        + New Rule Exception
                      </ModelMediumButton>
                    ) : (
                      <ModelMediumButton
                        variant='contained'
                        onClick={this.createException}
                        style={{
                          backgroundColor: getColorTheme('channelBidderPrimaryButton'),
                          boxShadow: `0px 0px 6px ${getColorTheme(
                            'channelBidderPrimaryButtonShadow',
                          )}`,
                          color: getColorTheme('channelBidderPrimaryButtonText'),
                        }}
                      >
                        + New Rule Exception
                      </ModelMediumButton>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Rule Exception Array */}
          {this.renderRuleExceptionsList()}
          {this.renderRuleExceptionEditor()}
          {this.renderBidderSelector()}
        </div>
      );
    };

    renderRuleTargetedExceptionDialog() {
      const { openRuleTargetedExceptionDialog } = this.state;
      return (
        <Dialog
          fullWidth
          keepMounted
          maxWidth='sm'
          onClose={() =>
            this.setState({
              openRuleTargetedExceptionDialog: false,
              openRuleTargetedExceptionDialogIABCode: '',
            })
          }
          open={openRuleTargetedExceptionDialog}
        >
          {/* TABLE WITH LIST OF ADDED ADOMAIN*/}
          <Grid container direction='row' justify='center' alignItems='center'>
            <Grid
              item
              style={{ height: '500px', width: '500px', maxHeight: '500px', margin: '20px' }}
            >
              {this.renderAdomainExceptionTable()}
            </Grid>
          </Grid>
        </Dialog>
      );
    }

    initializeMenuListFromTargetedIABs(): IMenuList {
      const { TargetedIABs } = this.state;
      const splitAllTargetedIABs = TargetedIABs.split(',');
      const iabMenuList = {} as IMenuList;
      for (const targetedIAB of splitAllTargetedIABs) {
        iabMenuList[targetedIAB] = {
          title: targetedIAB,
          selected: false,
          ID: targetedIAB,
        } as IListItem;
      }
      return iabMenuList;
    }

    generateMenuListFromBrandSafetyRuleException(
      brandSafetyRuleException: IBrandSafetyRuleException,
    ): IMenuList {
      const { TargetedIABs } = this.state;
      const splitAllTargetedIABs = TargetedIABs.split(',').filter(
        (targetedIAB) => targetedIAB !== '',
      );
      const iabMenuList = {} as IMenuList;
      for (const targetedIAB of splitAllTargetedIABs) {
        iabMenuList[targetedIAB] = {
          title: IABCategoryCodeToName(targetedIAB),
          selected: false,
          ID: targetedIAB,
        } as IListItem;
      }

      if (brandSafetyRuleException === undefined) {
        return iabMenuList;
      }
      const splitSelectedTargetedIABs = brandSafetyRuleException.TargetedIABExceptions.split(',');
      const filteredSelectedTargetedIABs = splitSelectedTargetedIABs.filter(
        (targetedIAB) => targetedIAB !== '',
      );
      for (const selectedTargetedIAB of filteredSelectedTargetedIABs) {
        iabMenuList[selectedTargetedIAB].selected = true;
      }

      return iabMenuList;
    }

    renderRuleExceptionEditor() {
      const { classes } = this.props;
      const {
        bidderListAllowed,
        BrandSafetyRuleExceptions,
        openEditRuleException,
        selectedRowIdx,
      } = this.state;
      const disabled = !this.state.hasWriteCurrentRuleRight.isAuthorized;

      let brandSafetyRuleException = {
        ID: 0,
        CreatedAt: '',
        UpdatedAt: '',
        DeletedAt: '',

        Name: '',
        BidderIDs: '',
        AllowedAdomains: '',
        AllowedIABCategories: '',
        TargetedIABExceptions: '',
      } as IBrandSafetyRuleException;

      if (selectedRowIdx !== undefined && BrandSafetyRuleExceptions[selectedRowIdx] !== undefined) {
        brandSafetyRuleException = BrandSafetyRuleExceptions[selectedRowIdx];
      }

      const brandSafetyRuleExceptionMenuList =
        this.generateMenuListFromBrandSafetyRuleException(brandSafetyRuleException);

      return (
        <Dialog
          fullWidth
          maxWidth='sm'
          keepMounted
          open={openEditRuleException}
          onClose={() => {
            this.setState({ openEditRuleException: false });
          }}
        >
          <div style={{ margin: 30, minHeight: 550 }}>
            {/* rule exception name */}
            <div className={classes.section}>
              <TextField
                label='Rule Exception Name'
                name='Name'
                fullWidth
                value={brandSafetyRuleException.Name}
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  if (selectedRowIdx !== undefined) {
                    const BrandSafetyRuleExceptions = cloneDeep(
                      this.state.BrandSafetyRuleExceptions,
                    );
                    BrandSafetyRuleExceptions[selectedRowIdx].Name = target.value;
                    this.setState({
                      BrandSafetyRuleExceptions,
                    });
                  }
                }}
              />
            </div>

            {/* bidder selector */}
            <div className={classes.section}>
              <MaterialSearchDropdownMulti
                getValueFromSearchElement={(src: IListItem) => src.title}
                selectAll={true}
                menuTitle='Bidders'
                list={bidderListAllowed}
                onChange={(bidderListAllowed: IMenuList) => {
                  this.setState({
                    bidderListAllowed,
                  });
                }}
                handleMenuAcceptClick={(list: IMenuList) => {
                  if (selectedRowIdx !== undefined) {
                    const BrandSafetyRuleExceptions = cloneDeep(
                      this.state.BrandSafetyRuleExceptions,
                    );
                    const selectedBidderIDs = [];
                    for (const key in list) {
                      if (list[key].selected) {
                        selectedBidderIDs.push(list[key].ID);
                      }
                    }
                    BrandSafetyRuleExceptions[selectedRowIdx].BidderIDs =
                      selectedBidderIDs.join(',');
                    this.setState({
                      BrandSafetyRuleExceptions,
                    });
                  }
                }}
                showPrefixID
              />
            </div>

            {this.state.ruleType === RuleTypeIAB && (
              <div className={classes.section}>
                <MaterialSearchDropdownMulti
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  selectAll={true}
                  menuTitle='IAB Categories'
                  list={brandSafetyRuleExceptionMenuList}
                  showPrefixID
                  onChange={(list: IMenuList) => {
                    if (selectedRowIdx !== undefined) {
                      const selectedTargetedIABs = [];
                      for (const key in list) {
                        if (list[key].selected) {
                          selectedTargetedIABs.push(list[key].ID);
                        }
                      }
                      BrandSafetyRuleExceptions[selectedRowIdx].TargetedIABExceptions =
                        selectedTargetedIABs.join(',');
                      this.setState({
                        BrandSafetyRuleExceptions,
                      });
                    }
                  }}
                />
              </div>
            )}

            {
              // if IAB, show Adomain exception
              this.state.ruleType === RuleTypeIAB && (
                <>
                  <Grid container direction='row' justify='flex-start' alignItems='flex-start'>
                    <Grid item style={{ marginRight: '20px' }}>
                      <ChipTypeSelected label='Adomain' />
                    </Grid>
                  </Grid>
                  {this.renderRuleTypeAdomainEntry(
                    RuleExceptionTab,
                    true,
                    disabled,
                    selectedRowIdx,
                  )}
                  <Divider style={{ height: '2px', marginTop: '16px', marginBottom: '6px' }} />
                </>
              )
            }

            {
              // if Adomain, show IAB exception
              this.state.ruleType === RuleTypeAdomain && (
                <>
                  <Grid container direction='row' justify='flex-start' alignItems='flex-start'>
                    <Grid item style={{ marginRight: '20px' }}>
                      <ChipTypeSelected label='IAB Cat.' />
                    </Grid>
                  </Grid>
                  {this.renderRuleTypeIABEntry(RuleExceptionTab, disabled, selectedRowIdx)}
                  <Divider style={{ height: '2px', marginTop: '16px', marginBottom: '6px' }} />
                </>
              )
            }
          </div>
        </Dialog>
      );
    }

    renderAllowedCreatives = () => {
      const listTableColumns: IListTableColumn[] = [
        {
          field: 'CreativeURL',
          title: 'Creative URL',
          renderType: 'playCreativeURL',
          searchable: true,
        },
        { field: 'Adomain', title: 'Adomain', renderType: 'normal', searchable: true },
        { field: 'IABCategory', title: 'IAB Category', renderType: 'normal', searchable: true },
      ];

      return (
        <Grid container direction='column'>
          <Grid item style={{ marginLeft: 15, width: '100%' }}>
            <ListTable
              title={''}
              resource='creative_validation'
              columns={listTableColumns}
              data={this.state.allowedCreativeValidations}
              loading={this.state.loadingCreativeValidations}
              fixedEnabled={true}
              enablePagination={true}
              pageSize={25}
              pageSizeOptions={[10, 25]}
              readRoleName={'read_channel_brandsafety_rule'}
              writeRoleName={'read_channel_brandsafety_rule'}
            />
          </Grid>
        </Grid>
      );
    };

    renderBidderSelector() {
      const { BrandSafetyRuleExceptions, headerBidders, openBidderSelectTable, selectedRowIdx } =
        this.state;
      return (
        selectedRowIdx !== undefined &&
        !!BrandSafetyRuleExceptions[selectedRowIdx] && (
          <Dialog
            fullWidth
            maxWidth='sm'
            keepMounted
            open={openBidderSelectTable}
            onClose={() => {
              this.setState({ openBidderSelectTable: false });
            }}
          >
            <ModalSelectTable
              title='Bidders'
              items={headerBidders.filter((hb: IHeaderBidder) =>
                BrandSafetyRuleExceptions[selectedRowIdx].BidderIDs.split(',').includes(hb.ID),
              )}
              onSelectRow={(hbID: string) => {
                this.setState(
                  {
                    openBidderSelectTable: false,
                  },
                  () => {
                    navigate(RouteBidderSettingsExisting, extractRouteParams(this.props), {
                      b: hbID,
                    });
                  },
                );
              }}
              interactive={true}
            />
          </Dialog>
        )
      );
    }

    // define tabs and corresponding render functions
    renderTabs = (): ReactElement => {
      const tabs: ITab[] = [
        {
          label: 'Rule',
          render: () => this.renderRuleTargetingTab(),
        },
      ];
      if (
        this.state.ruleType !== RuleTypeMediafile &&
        this.state.RuleTargetingType !== BrandSafetyRuleTargetingTypeBidder &&
        this.state.RuleTargetingType !== BrandSafetyRuleTargetingTypeBidderGroup
      ) {
        tabs.push({
          label: 'Exceptions',
          render: () => this.renderRuleExceptionsTab(),
        });
      }
      tabs.push({
        label: 'Allowed Creatives',
        render: () => this.renderAllowedCreatives(),
      });

      return (
        <SettingsTabs
          marginTop={0}
          marginBottom={15}
          maxTabWidth='1200px'
          renderDrawer={this.renderRuleSummary.bind(this)}
          tabs={tabs}
        />
      );
    };

    // ############################## MAIN RENDER ##############################
    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel largeHorizontalPadding verticalPadding>
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>
            {/* TOP BAR*/}
            {this.renderTopBar(classes)}
          </Panel>
          <Panel scroll largePadding>
            {/* PAGE CONTENT*/}
            <div
              style={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                boxShadow: '0px 3px 6px #CBCBCB',
                borderRadius: bigRadius,
                paddingLeft: '2%',
              }}
            >
              {this.renderTabs()}
            </div>

            {/* SNACKBAR (for notifications)*/}
            <SnackbarView
              open={!!this.state.snackbarMessage}
              error={this.state.snackbarError}
              onClose={this.snackbarClose}
            >
              {this.state.snackbarMessage}
            </SnackbarView>

            {/* DELETE CONFIRMATION POPUP*/}
            <ModelDialogDeleteView
              active={this.state.deletePopupActive}
              model='Rule'
              ID={this.state.ID}
              Name={this.state.Name}
              deleteModel={(rule_id: string) => {
                return this.deleteRuleWithPromise(Number(rule_id));
              }}
              onDelete={this.onDeleteDeleteDialog}
              onError={this.onHideDeleteDialog}
              onClose={this.onHideDeleteDialog}
            />
          </Panel>
        </Panels>
      );
    }
  },
);
